import HELPERS from '@/modules/OperatorPanel/helpers';
import Vue from 'vue';
// import axios from '../../axios-middleware';
import axios from 'axios';
import i18n from '@/lang/i18n.js';
import kwizbotModuleSettings from '@/modules/OperatorPanel/kwizbot_settings.js';
import { v4 as uuid_v4 } from 'uuid';
import merge from 'lodash/merge';
import _ from 'lodash';

let opRoomsByFolderTypeLastKey = '';

const options = {
  // second: "2-digit",
  // minute: "2-digit",
  // hour: "2-digit",
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
};
const INTL = new Intl.DateTimeFormat('ru-RU', options);

// Утилиты для работы с группировками (оптимизация для 2000+ диалогов)
const GroupingUtils = {
  // Извлечение группировочных ключей из диалога
  extractGroupKeys(dialog, currentUserId) {
    const keys = {
      operators: new Set(),
      subjects: new Set(),
      channels: new Set(),
      bots: new Set(),
      statuses: new Set(),
      tags: new Set(),
      isMyDialog: false,
      isUnassigned: false,
      isQueue: false,
    };

    // Операторы
    if (dialog.participants) {
      dialog.participants.forEach(participant => {
        if (participant.type === 'user' && participant.user_id) {
          keys.operators.add(participant.user_id);
          if (participant.user_id === currentUserId) {
            keys.isMyDialog = true;
          }
        }
      });
    }

    // Проверка на неназначенные
    keys.isUnassigned = keys.operators.size === 0;

    // Темы
    if (dialog.subject_id) {
      keys.subjects.add(dialog.subject_id);
    } else {
      keys.subjects.add('null');
    }

    // Каналы
    if (dialog.kw_channel) {
      keys.channels.add(dialog.kw_channel);
    }

    // Боты
    if (dialog.bot_id) {
      keys.bots.add(dialog.bot_id);
    }

    // Статусы names
    if (dialog.status_name) {
      keys.statuses.add(dialog.status_name);
    }

		//queue
		keys.isQueue = dialog.status === 'queue';

    // Теги
    if (dialog.chatroom_tags) {
      dialog.chatroom_tags.forEach(tag => {
        if (tag.name) {
          keys.tags.add(tag.name);
        }
      });
    }

    return keys;
  },

  // Сравнение ключей для определения изменений
  compareGroupKeys(oldKeys, newKeys) {
    const changes = {
      operators: { added: new Set(), removed: new Set() },
      subjects: { added: new Set(), removed: new Set() },
      channels: { added: new Set(), removed: new Set() },
      bots: { added: new Set(), removed: new Set() },
      statuses: { added: new Set(), removed: new Set() },
      tags: { added: new Set(), removed: new Set() },
      myDialog: oldKeys.isMyDialog !== newKeys.isMyDialog,
      unassigned: oldKeys.isUnassigned !== newKeys.isUnassigned,
      queue: oldKeys.isQueue !== newKeys.isQueue,
    };

    // Вычисляем изменения для каждой группы
    Object.keys(changes).forEach(groupType => {
      if (typeof changes[groupType] === 'object' && changes[groupType].added) {
        const oldSet = oldKeys[groupType] || new Set();
        const newSet = newKeys[groupType] || new Set();

        // Добавленные
        newSet.forEach(key => {
          if (!oldSet.has(key)) {
            changes[groupType].added.add(key);
          }
        });

        // Удаленные
        oldSet.forEach(key => {
          if (!newSet.has(key)) {
            changes[groupType].removed.add(key);
          }
        });
      }
    });

    return changes;
  },

  // Применение изменений к кэшированным группировкам
  applyChanges(state, dialogId, changes) {
    const { cachedGroupings, groupCounts } = state.operator_panel;

    // Операторы
    changes.operators.added.forEach(operatorId => {
      if (!cachedGroupings.byOperator.has(operatorId)) {
        cachedGroupings.byOperator.set(operatorId, new Set());
      }
      cachedGroupings.byOperator.get(operatorId).add(dialogId);
      groupCounts.operators.set(operatorId, (groupCounts.operators.get(operatorId) || 0) + 1);
    });

    changes.operators.removed.forEach(operatorId => {
      const group = cachedGroupings.byOperator.get(operatorId);
      if (group) {
        group.delete(dialogId);
        const newCount = Math.max(0, (groupCounts.operators.get(operatorId) || 0) - 1);
        if (newCount === 0) {
          cachedGroupings.byOperator.delete(operatorId);
          groupCounts.operators.delete(operatorId);
        } else {
          groupCounts.operators.set(operatorId, newCount);
        }
      }
    });

    // Аналогично для остальных групп
    this.applyGroupChanges(cachedGroupings.bySubject, groupCounts.subjects, changes.subjects, dialogId);
    this.applyGroupChanges(cachedGroupings.byChannel, groupCounts.channels, changes.channels, dialogId);
    this.applyGroupChanges(cachedGroupings.byBot, groupCounts.bots, changes.bots, dialogId);

    // Отдельное логирование для statuses (by_statuses папка)
    // if (changes.statuses.added.size > 0 || changes.statuses.removed.size > 0) {
    //   console.log('📊 Status changes for by_statuses:', {
    //     dialogId,
    //     added: Array.from(changes.statuses.added),
    //     removed: Array.from(changes.statuses.removed)
    //   });
    // }
    this.applyGroupChanges(cachedGroupings.byStatus, groupCounts.statuses, changes.statuses, dialogId);
    this.applyGroupChanges(cachedGroupings.byTag, groupCounts.tags, changes.tags, dialogId);

    // Специальные группы
    if (changes.myDialog) {
      if (cachedGroupings.myDialogs.has(dialogId)) {
        cachedGroupings.myDialogs.delete(dialogId);
        groupCounts.my = Math.max(0, groupCounts.my - 1);
      } else {
        cachedGroupings.myDialogs.add(dialogId);
        groupCounts.my += 1;
      }
    }

    if (changes.unassigned) {
      if (cachedGroupings.unassigned.has(dialogId)) {
        cachedGroupings.unassigned.delete(dialogId);
        groupCounts.unassigned = Math.max(0, groupCounts.unassigned - 1);
      } else {
        cachedGroupings.unassigned.add(dialogId);
        groupCounts.unassigned += 1;
      }
    }

    if (changes.queue) {
      const wasInQueue = cachedGroupings.queue.has(dialogId);
      const oldCount = groupCounts.queue;

      if (wasInQueue) {
        cachedGroupings.queue.delete(dialogId);
        groupCounts.queue = Math.max(0, groupCounts.queue - 1);
        // console.log('📤 Removed from queue:', { dialogId, oldCount, newCount: groupCounts.queue });
      } else {
        cachedGroupings.queue.add(dialogId);
        groupCounts.queue += 1;
        // console.log('📥 Added to queue:', { dialogId, oldCount, newCount: groupCounts.queue });
      }
    }
  },

  applyGroupChanges(groupMap, countMap, changes, dialogId) {
    changes.added.forEach(key => {
      if (!groupMap.has(key)) {
        groupMap.set(key, new Set());
      }
      groupMap.get(key).add(dialogId);
      countMap.set(key, (countMap.get(key) || 0) + 1);
    });

    changes.removed.forEach(key => {
      const group = groupMap.get(key);
      if (group) {
        group.delete(dialogId);
        const newCount = Math.max(0, (countMap.get(key) || 0) - 1);
        if (newCount === 0) {
          groupMap.delete(key);
          countMap.delete(key);
        } else {
          countMap.set(key, newCount);
        }
      }
    });
  },

  // Универсальный пересчет одной группы (groupType, groupId)
  rebuildGroup(state, groupType, groupId, currentUserId) {
    const chatRooms = state.operator_panel.chatRooms || [];
    switch (groupType) {
      case 'operator':
      case 'by_operators': {
        // Пересобираем только для одного оператора
        const dialogs = chatRooms.filter(room =>
          room.participants?.some(p => p.type === 'user' && p.user_id === groupId)
        );
        const group = new Set();
        dialogs.forEach(d => group.add(d.id));
        state.operator_panel.cachedGroupings.byOperator.set(groupId, group);
        state.operator_panel.groupCounts.operators.set(groupId, group.size);
        break;
      }
      case 'subject':
      case 'by_subjects': {
        const dialogs = chatRooms.filter(room => room.subject_id === groupId);
        const group = new Set();
        dialogs.forEach(d => group.add(d.id));
        state.operator_panel.cachedGroupings.bySubject.set(groupId, group);
        state.operator_panel.groupCounts.subjects.set(groupId, group.size);
        break;
      }
      case 'channel':
      case 'by_channels': {
        const dialogs = chatRooms.filter(room => room.kw_channel === groupId);
        const group = new Set();
        dialogs.forEach(d => group.add(d.id));
        state.operator_panel.cachedGroupings.byChannel.set(groupId, group);
        state.operator_panel.groupCounts.channels.set(groupId, group.size);
        break;
      }
      case 'bot':
      case 'by_bots': {
        const dialogs = chatRooms.filter(room => room.bot_id === groupId);
        const group = new Set();
        dialogs.forEach(d => group.add(d.id));
        state.operator_panel.cachedGroupings.byBot.set(groupId, group);
        state.operator_panel.groupCounts.bots.set(groupId, group.size);
        break;
      }
      case 'status':
      case 'by_statuses': {
        const dialogs = chatRooms.filter(room => room.status_name === groupId);
        const group = new Set();
        dialogs.forEach(d => group.add(d.id));
        state.operator_panel.cachedGroupings.byStatus.set(groupId, group);
        state.operator_panel.groupCounts.statuses.set(groupId, group.size);
        break;
      }
      case 'tag':
      case 'by_tags': {
        const dialogs = chatRooms.filter(room =>
          Array.isArray(room.chatroom_tags) && room.chatroom_tags.some(tag => tag.name === groupId)
        );
        const group = new Set();
        dialogs.forEach(d => group.add(d.id));
        state.operator_panel.cachedGroupings.byTag.set(groupId, group);
        state.operator_panel.groupCounts.tags.set(groupId, group.size);
        break;
      }
      case 'my': {
        const dialogs = chatRooms.filter(room =>
          room.participants?.some(p => p.type === 'user' && p.user_id === currentUserId)
        );
        const group = new Set();
        dialogs.forEach(d => group.add(d.id));
        state.operator_panel.cachedGroupings.myDialogs = group;
        state.operator_panel.groupCounts.my = group.size;
        break;
      }
      case 'unassigned': {
        const dialogs = chatRooms.filter(room =>
          !(room.participants && room.participants.some(p => p.type === 'user'))
        );
        const group = new Set();
        dialogs.forEach(d => group.add(d.id));
        state.operator_panel.cachedGroupings.unassigned = group;
        state.operator_panel.groupCounts.unassigned = group.size;
        break;
      }
      case 'queue': {
        const dialogs = chatRooms.filter(room => room.status === 'queue');
        const group = new Set();
        dialogs.forEach(d => group.add(d.id));
        state.operator_panel.cachedGroupings.queue = group;
        state.operator_panel.groupCounts.queue = group.size;
        break;
      }
      // Для остальных типов — ничего не делаем
    }
  },
};

const state = {
  operator_panel: {
    chatRooms: [],

    // Оптимизированные структуры для устранения фризов
    cachedGroupings: {
      byOperator: new Map(),   // operatorId -> Set<dialogId>
      bySubject: new Map(),    // subjectId -> Set<dialogId>
      byChannel: new Map(),    // channelName -> Set<dialogId>
      byBot: new Map(),        // botId -> Set<dialogId>
      byStatus: new Map(),     // statusName -> Set<dialogId>
      byTag: new Map(),        // tagName -> Set<dialogId>
      myDialogs: new Set(),    // Set<dialogId> для текущего пользователя
      unassigned: new Set(),   // Set<dialogId> для неназначенных
      queue: new Set(),        // Set<dialogId> для очереди
    },

    // Быстрые счетчики (обновляются инкрементально)
    groupCounts: {
      operators: new Map(),   // operatorId -> count
      subjects: new Map(),    // subjectId -> count
      channels: new Map(),    // channelName -> count
      bots: new Map(),        // botId -> count
      statuses: new Map(),    // statusName -> count
      tags: new Map(),        // tagName -> count
      my: 0,
      unassigned: 0,
      queue: 0,
      all: 0,
    },

    // Мета-информация для оптимизации
    lastUpdateTimestamp: Date.now(),
    pendingUpdates: new Set(), // Set<dialogId> ожидающих обновления
    isUpdating: false,
    needsGroupingRebuild: false, // Флаг для отложенной перестройки группировок

    notification: false,
    activeChatGroup: null,
    activeChatRoom: null,
    serverTime: null,
    subjectList: [],
    subjectListTree: [],
    rebuildKey: Date.now(),

    chatRoomGroups: [],
    typeChatRooms: {type: '', id: ''},
    typeChatRoomsEnum: {
      all: 'all',
      unassigned: 'unassigned',
      my: 'my',
      operator: 'operator',
      subject: 'subject',
			skill_group: 'skill_group',
      closedChats: 'closedChats',
			queue: 'queue',
			channel: 'channel',
			bot: 'bot',
			status: 'status',
			tag: 'tag',
			ticket_assignee_my: 'ticket_assignee_my',
			ticket_reporter_me: 'ticket_reporter_me',
			outdated: 'outdated',
			resolved: 'resolved',
			paused: 'paused',
			no_answer: 'no_answer',
    },

		chatRoomFolders: [
			{
				"name": i18n.t('modules.op.texts.all_active'),
				"key": 'all',
				"order": 1,
				"enabled": true,
				"fixed": false,
				"icon": "mdi-all-inclusive",
				"type": "item",
				"default": false,
				"group_by_subjects": true,
				"filter_by_type": ['chat', 'ticket'],
			},
			{
				"name": i18n.t('modules.op.texts.unassigned'),
				"key": 'unassigned',
				"order": 2,
				"enabled": true,
				"fixed": false,
				"icon": "mdi-chat-alert-outline",
				"type": "item",
				"default": false,
				"group_by_subjects": true,
				"filter_by_type": ['chat', 'ticket'],
			},
			{
				"name": i18n.t('modules.op.texts.chat_assigned_to_me'),
				"key": 'my',
				"order": 3,
				"enabled": true,
				"fixed": false,
				"icon": "mdi-chat-processing-outline",
				"type": "item",
				"default": true,
				"group_by_subjects": true,
				"filter_by_type": ['chat'],
			},
			{
				"name": i18n.t('modules.op.texts.ticket_assigned_to_me'),
				"key": 'ticket_assignee_my',
				"order": 4,
				"enabled": true,
				"fixed": false,
				"icon": "mdi-chat-processing-outline",
				"type": "item",
				"default": false,
				"group_by_subjects": true,
				"filter_by_type": ['ticket'],
			},
			{
				"name": i18n.t('modules.op.texts.ticket_reporter_me'),
				"key": 'ticket_reporter_me',
				"order": 5,
				"enabled": true,
				"fixed": false,
				"icon": "mdi-chat-processing-outline",
				"type": "item",
				"default": false,
				"group_by_subjects": true,
				"filter_by_type": ['ticket'],
			},
			{
				"name": i18n.t('modules.op.texts.resolved'),
				"key": 'resolved',
				"order": 12,
				"enabled": true,
				"fixed": false,
				"icon": "mdi-chat-processing-outline",
				"type": "item",
				"default": false,
				"group_by_subjects": true,
				"filter_by_type": ['ticket'],
			},
			{
				"name": i18n.t('modules.op.texts.outdated'),
				"key": 'outdated',
				"order": 13,
				"enabled": true,
				"fixed": false,
				"icon": "mdi-chat-processing-outline",
				"type": "item",
				"default": false,
				"group_by_subjects": true,
				"filter_by_type": ['ticket'],
			},
			{
				"name": i18n.t('modules.op.texts.in_queue'),
				"key": 'queue',
				"order": 6,
				"enabled": true,
				"fixed": false,
				"icon": "mdi-account-multiple-outline",
				"type": "item",
				"default": false,
				"group_by_subjects": true,
				"filter_by_type": ['chat', 'ticket'],
			},
			{
				"name": i18n.t('modules.op.texts.no_answer'),
				"key": 'no_answer',
				"order": 15,
				"enabled": true,
				"fixed": false,
				"icon": "message-question-outline",
				"type": "item",
				"default": false,
				"group_by_subjects": true,
				"filter_by_type": ['chat', 'ticket'],
			},

			{
				"name": i18n.t('modules.op.texts.by_operators'),
				"key": 'by_operators',
				"order": 7,
				"enabled": true,
				"fixed": false,
				"icon": "",
				"type": "group",
				"item_key": "operator",
				"default": false,
				"group_by_subjects": true,
				"filter_by_type": ['chat', 'ticket'],
			},
			{
				"name": i18n.t('modules.op.texts.by_skill_groups'),
				"key": 'by_skill_groups',
				"order": 8,
				"enabled": true,
				"fixed": false,
				"icon": "",
				"type": "group",
				"item_key": "skill_group",
				"default": false,
				"filter_by_type": ['chat', 'ticket'],
			},
			{
				"name": i18n.t('modules.op.texts.by_subjects'),
				"key": 'by_subjects',
				"order": 8,
				"enabled": true,
				"fixed": false,
				"icon": "",
				"type": "group",
				"item_key": "subject",
				"default": false,
				"filter_by_type": ['chat', 'ticket'],
			},
			{
				"name": i18n.t('modules.op.texts.by_channel'),
				"key": 'by_channels',
				"order": 9,
				"enabled": true,
				"fixed": false,
				"icon": "",
				"type": "group",
				"item_key": "channel",
				"default": false,
				"group_by_subjects": true,
				"filter_by_type": ['chat', 'ticket'],
			},
			{
				"name": i18n.t('modules.op.texts.by_bots'),
				"key": 'by_bots',
				"order": 10,
				"enabled": true,
				"fixed": false,
				"icon": "",
				"type": "group",
				"item_key": "bot",
				"default": false,
				"group_by_subjects": true,
				"filter_by_type": ['chat', 'ticket'],
			},
			{
				"name": i18n.t('modules.op.texts.by_statuses'),
				"key": 'by_statuses',
				"order": 11,
				"enabled": true,
				"fixed": false,
				"icon": "",
				"type": "group",
				"item_key": "status",
				"default": false,
				"group_by_subjects": true,
				"filter_by_type": ['chat', 'ticket'],
			},
			{
				"name": i18n.t('modules.op.texts.by_tags'),
				"key": 'by_tags',
				"order": 12,
				"enabled": true,
				"fixed": false,
				"icon": "",
				"type": "group",
				"item_key": "tag",
				"default": false,
				"group_by_subjects": true,
				"filter_by_type": ['chat', 'ticket'],
			},
		],
		chatRoomFoldersTODO: [
			// {
			// 	"name": "Created By Me",
			// 	"key": 'created_by_me',
			// 	"order": 11,
			// 	"enabled": true,
			// 	"fixed": false,
			// 	"icon": "",
			// 	"type": "item",
			// },
			// {
			// 	"name": "Created Grouped",
			// 	"key": 'Created by Grouped',
			// 	"order": 12,
			// 	"enabled": true,
			// 	"fixed": false,
			// 	"icon": "",
			// 	"type": "item",
			// },
			// {
			// 	"name": "Internal",
			// 	"key": 'internal',
			// 	"order": 13,
			// 	"enabled": true,
			// 	"fixed": false,
			// 	"icon": "",
			// 	"type": "item",
			// },
		],


		chatRoomsSorting: 'default',
		chatRoomsSortingEnum: [
			{
				label: i18n.t('modules.op.texts.chat_rooms_menu.sorting.by_default'),
				value: "default",
			},
			{
				label: i18n.t('modules.op.texts.chat_rooms_menu.sorting.by_created'),
				value: "created",
			},
			{
				label: i18n.t('modules.op.texts.chat_rooms_menu.sorting.by_user'),
				value: "user",
			},
			{
				label: i18n.t('modules.op.texts.chat_rooms_menu.sorting.by_message_read'),
				value: "message_read",
			},

		],

    searchChatRoomsInput: '',

    groupByTheme: false,

    closedChatRoomsShow: false,

		closedRoomsSearchParamsDefault: {
			// order
			order: null,
			//bot_id
			bot_id: [],
			//kw_channel
			kw_channel: null,
			//users List
			operators: [],
			//skill_groups_ids
			skill_groups_ids: [],
			//subjects List
			subjects: [],
			//tags
			tags: [],
			//days toggle
			days: 7,
			//dates range
			from: new Date(new Date().setDate(new Date().getDate() - 6)).toISOString().slice(0, 10),
			to: new Date().toISOString().slice(0, 10),
			//clients text
			search: null,
			//groupBy
			group: null,
			//last Msg from Client
			no_answer: null,
		},
    closedRoomsSearchParams: {
			// order
			order: null,
			//bot_id
			bot_id: [],
			//kw_channel
			kw_channel: null,
			//users List
			operators: [],
			//skill_groups_ids
			skill_groups_ids: [],
			//subjects List
			subjects: [],
			//tags
			tags: [],
      //days toggle
      days: 7,
      //dates range
      from: new Date(new Date().setDate(new Date().getDate() - 6)).toISOString().slice(0, 10),
      to: new Date().toISOString().slice(0, 10),
      //clients text
      search: null,
      //groupBy
      group: null,
			//last Msg from Client
			no_answer: null,
    },
    closedRoomsSearchParamGroupByEnum: [
      {name: i18n.t('modules.op.search.item_operator'), value: "operator"},
      {name: i18n.t('modules.op.search.item_subject'), value: "subject"},
      {name: i18n.t('modules.op.search.item_date'), value: "date"},
      {name: i18n.t('modules.op.search.item_client'), value: "client"},
    ],
    closedRoomsSearch: [],
		tagsList: [],

		closedChatRoomData: null,

		bots_tokens: {},

    channels_message_reactions_config: {},
  },
};

const mutations = {
  OP_SET_CHAT_ROOMS(state, chatRooms) {
		try {
			const baseMap = new Map(state.operator_panel.chatRooms.map(item => [item.id, item]));
			const newArray = chatRooms.map(item => {
				const baseItem = baseMap.get(item.id);
				if (baseItem && Array.isArray(baseItem.messages) && baseItem.messages.length > item.messages.length) {
					return {
						...item,
						messages: baseItem.messages
					};
				}
				return item;
			}) || [];

			Vue.set(state.operator_panel, 'chatRooms', newArray);

			// Устанавливаем флаг что нужно пересчитать группировки
			// Это будет обработано в OpAxiosGetChatRooms через dispatch('rebuildAllGroupings')
			state.operator_panel.needsGroupingRebuild = true;
		} catch(error) {
			console.log(error, 'OP_SET_CHAT_ROOMS')
			Vue.set(state.operator_panel, 'chatRooms', chatRooms);
			state.operator_panel.needsGroupingRebuild = true;
		}
  },

	OP_UPDATE_CHAT_ROOM_STATE(state, {index, chatRoom}) {
		if (index !== -1) {
			Vue.set(state.operator_panel.chatRooms, index, chatRoom);
		} else {
			state.operator_panel.chatRooms = [...state.operator_panel.chatRooms, chatRoom]
			state.operator_panel.chatRooms = state.operator_panel.chatRooms.sort((a, b) => a.id - b.id);
		}
	},

	OP_UPDATE_STATUS_CHAT_ROOM_STATE(state, {index, status}) {
		Vue.set(state.operator_panel.chatRooms[index], 'status', status);
	},
	OP_UPDATE_STATUS_NAME_CHAT_ROOM_STATE(state, {index, status}) {
		Vue.set(state.operator_panel.chatRooms[index], 'status_name', status);
	},
	OP_UPDATE_TAGS_CHAT_ROOM_STATE(state, {index, chatroom_tags}) {
		Vue.set(state.operator_panel.chatRooms[index], 'chatroom_tags', chatroom_tags);
	},
	OP_UPDATE_TYPE_CHAT_ROOM_STATE(state, {index, type}) {
		Vue.set(state.operator_panel.chatRooms[index], 'type', type);
	},
	OP_UPDATE_CHAT_ROOM_STATE_BY_KEY(state, {index, key, value}) {
		Vue.set(state.operator_panel.chatRooms[index], key, value);
	},

	OP_UPDATE_TYPE_CHAT_ROOM_TICKET(state, {index, chatroom_ticket}) {
		Vue.set(state.operator_panel.chatRooms[index], 'chatroom_ticket', chatroom_ticket);
	},

	OP_REMOVE_CHAT_ROOM_STATE(state, chat_room_id){
		const index = state.operator_panel.chatRooms.findIndex(obj => obj.id === chat_room_id);
		if (index !== -1) {
			state.operator_panel.chatRooms.splice(index, 1);
		}
	},

	OP_UPDATE_PARTICIPANT_CHAT_ROOM_STATE(state, { index, participants }){
		Vue.set(state.operator_panel.chatRooms[index], 'participants', participants);
	},

	OP_UPDATE_CLIENT_FULL_NAME_CHAT_ROOM_STATE(state, { id, full_name }){
		try {
			state.operator_panel.chatRooms
				.find((item) => item.id === id).participants
				.find((item) => item.client_id).client.full_name = full_name
		} catch(error) {
			console.log(error, 'OP_UPDATE_CLIENT_FULL_NAME_CHAT_ROOM_STATE')
		}
	},

	OP_REMOVE_PARTICIPANT_CHAT_ROOM_STATE(state, {index, participants}){
		Vue.set(state.operator_panel.chatRooms[index], 'participants', participants);
	},

  OP_SET_ACTIVE_CHAT_GROUP(state, chatGroupId) {
    Vue.set(state.operator_panel, 'activeChatGroup', chatGroupId);
  },

  OP_SET_ACTIVE_CHAT_ROOM(state, chatRoomId) {
    Vue.set(state.operator_panel, 'activeChatRoom', chatRoomId);
  },

	OP_SET_ACTIVE_CHAT_ROOM_BY_KEY(state, { key, value } ) {
		Vue.set(state.operator_panel.activeChatRoom, key, value);
	},

  OP_SET_CHAT_ROOM_PARTICIPANTS(state, chatRoom) {
    const participants = HELPERS.formatDialogParticipants(chatRoom);
    Vue.set(state.operator_panel.active_chat, 'participants', participants);
  },

  OP_SET_SERVER_TIME(state, dateStr) {
    state.operator_panel.serverTime = dateStr;
  },

  OP_SET_SUBJECT_LIST(state, subjectList) {
    state.operator_panel.subjectList = subjectList;
  },

  OP_SET_SUBJECT_LIST_TREE(state, subjectList) {
    state.operator_panel.subjectListTree = subjectList;
  },

  OP_SET_ACTIVE_CHAT_ROOM_URL(state, chatRoomId) {
    const menuItem = kwizbotModuleSettings.module_settings.menu_items[0];

    let url = `/${menuItem.route}/chats`;

    if (chatRoomId) {
      url += `?chat_room_id=${chatRoomId}`;
    }

    // enable/disable add chats?chat_id to url
    window.history.pushState(menuItem.title, 'title', url);
  },

  OP_SET_REBUILD_KEY(state, rebuildKey) {
    state.operator_panel.rebuildKey = rebuildKey;
  },

  OP_SET_CHAT_NOTINICATION(state, message) {
    const { chatRooms } = state.operator_panel;
    const room = chatRooms.find((v) => v.id === message?.data?.chat_room_id);

    state.operator_panel.notification = true;

    if (room) {
      const activeMessage = room.messages.find((v) => v.id === message.data.id);

      if (activeMessage) {
        activeMessage.message_read = message.data.message_read;
      } else {

        //add to message param "send_datetime" from "updatedAt"
        if ( !message.data?.send_datetime )
          message.data['send_datetime'] = message.data.updatedAt.replace('T', ' ').split('.')[0]

        room.messages.push(message.data);
      }
    }
  },
  OP_ADD_MESSAGE_TO_ACTIVE_CHATROOMS (state, message) {
    const { chatRooms } = state.operator_panel;
    const room = chatRooms.find((v) => v.id === message?.data?.chat_room_id);

    state.operator_panel.notification = false;

    if (room) {
      //add to message param "send_datetime" from "updatedAt"
      if ( !message.data?.send_datetime )
        message.data['send_datetime'] = message.data.updatedAt.replace('T', ' ').split('.')[0]

      message.data.message_read = true

      room.messages.push(message.data);

			//push to active dialog One msg
			const userId = state.operator_panel.userInfo.id;
			const options = { messages: [message.data], userId };
			// Find the index where the object should be inserted
			const index = state.operator_panel.active_chat.messageList
				.findIndex(item => item.id > message.data.id);
			// If no larger ID is found, index will be -1, and we should push at the end of the array
			if (index === -1) {
				state.operator_panel.active_chat.messageList.push(HELPERS.formatDialogMsgs(options)[0]);
			} else {
				state.operator_panel.active_chat.messageList.splice(index, 0, HELPERS.formatDialogMsgs(options));
			}
			// state.operator_panel.active_chat.messageList = [...state.operator_panel.active_chat.messageList, ...HELPERS.formatDialogMsgs(options)];
    }
  },

	OP_ADD_MESSAGE_TO_CHATROOM(state, message) {
		const { chatRooms } = state.operator_panel;
		const room = chatRooms.find((v) => v.id === message?.data?.chat_room_id);

		state.operator_panel.notification = false;

		if (room) {
			//add to message param "send_datetime" from "updatedAt"
			if ( !message.data?.send_datetime )
				message.data['send_datetime'] = message.data.updatedAt.replace('T', ' ').split('.')[0]

			// message.data.message_read = true

			room.messages.push(message.data);

			// set all message read in chatRoom
			room.messages.forEach((r) => (r.message_read = true));
		}
	},

  OP_SET_CHAT_READ(state, chatId) {
    const { chatRooms } = state.operator_panel;
    const room = chatRooms.find((v) => v.id === chatId);

    state.operator_panel.notification = false;

    if (room) {
      room.messages.forEach((r) => (r.message_read = true));
    }
  },

  OP_SET_TYPE_CHAT_ROOMS(state, typeChatRoomsVal) {
    state.operator_panel.typeChatRooms = typeChatRoomsVal
  },

  OP_SET_GROUP_BY_THEME(state, groupByTheme) {
    state.operator_panel.groupByTheme = groupByTheme
  },

  OP_SET_CHAT_ROOM_GROUPS(state, chatRoomGroups) {
    state.operator_panel.chatRoomGroups = chatRoomGroups
  },

  OP_SET_CLOSED_CHAT_ROOMS_SHOW(state, value) {
    state.operator_panel.closedChatRoomsShow = value
  },

  OP_SET_SEARCH_CHAT_ROOMS_INPUT(state, value) {
    state.operator_panel.searchChatRoomsInput = value
  },

  OP_SET_CLOSED_ROOMS_SEARCH(state, value) {
    state.operator_panel.closedRoomsSearch = value
  },

  OP_SET_CLOSED_ROOMS_SEARCH_PARAMS(state, value) {
    Vue.set(
      state.operator_panel.closedRoomsSearchParams,
      Object.keys(value)[0],
      value[Object.keys(value)[0]]
    )
  },

	OP_DELETE_CLOSED_ROOMS_SEARCH_PARAMS(state, value) {
		delete state.operator_panel.closedRoomsSearchParams?.[ Object.keys(value)[0] ]
	},

	OP_SET_CLOSED_ROOMS_SEARCH_PARAMS_TO_DEFAULT(state) {
		state.operator_panel.closedRoomsSearchParams = JSON.parse(JSON.stringify(state.operator_panel.closedRoomsSearchParamsDefault))
	},

	OP_SET_TAGS_LIST(state, payload) {
		state.operator_panel.tagsList = payload
	},

	OP_SET_CLOSED_CHAT_ROOM_DATA(state, data) {
		state.operator_panel.closedChatRoomData = data
	},
	OP_SET_CLOSED_CHAT_ROOM_DATA_BY_VALUE(state, value) {
		Vue.set(
			state.operator_panel.closedChatRoomData,
			Object.keys(value)[0],
			value[Object.keys(value)[0]]
		)
	},

	OP_SET_CHAT_ROOM_FOLDERS(state, data) {
		state.operator_panel.chatRoomFolders = data
	},

	OP_CHAT_ROOMS_SORTING(state, value) {
		state.operator_panel.chatRoomsSorting = value
	},

  OP_SET_CHANNELS_MESSAGE_REACTIONS_CONFIG(state, payload) {
    const { channel, data } = payload;

    Vue.set(state.operator_panel.channels_message_reactions_config, channel, data);
  },

	OP_REBUILD_ALL_GROUPINGS(state, currentUserId = null) {
		// Если currentUserId не передан, пытаемся получить из state (fallback)
		if (!currentUserId) {
			currentUserId = state.operator_panel.userInfo?.id;
		}

		if (!currentUserId) {
			console.warn('⚠️ Не удалось получить currentUserId для перестройки группировок');
			return;
		}

		// Проверяем, включена ли принудительная оптимизация
		const isHardLoadEnabled = this.getters?.is_chat_rooms_hard_load;
		if (!isHardLoadEnabled) {
			// Если принудительная оптимизация отключена, не выполняем кеширование
			// console.log('💡 Group optimization is disabled (is_chat_rooms_hard_load = false)');
			return;
		}

		// console.log('🔄 Полная перестройка группировок для', state.operator_panel.chatRooms.length, 'диалогов');

		// Очищаем все группировки
		state.operator_panel.cachedGroupings = {
			byOperator: new Map(),
			bySubject: new Map(),
			byChannel: new Map(),
			byBot: new Map(),
			byStatus: new Map(),
			byTag: new Map(),
			myDialogs: new Set(),
			unassigned: new Set(),
			queue: new Set(),
		};

		// Очищаем счетчики
		state.operator_panel.groupCounts = {
			operators: new Map(),
			subjects: new Map(),
			channels: new Map(),
			bots: new Map(),
			statuses: new Map(),
			tags: new Map(),
			my: 0,
			unassigned: 0,
			queue: 0,
			all: state.operator_panel.chatRooms.length,
		};

		// Пересчитываем все группировки
		state.operator_panel.chatRooms.forEach(dialog => {
			const keys = GroupingUtils.extractGroupKeys(dialog, currentUserId);
			const changes = {
				operators: { added: keys.operators, removed: new Set() },
				subjects: { added: keys.subjects, removed: new Set() },
				channels: { added: keys.channels, removed: new Set() },
				bots: { added: keys.bots, removed: new Set() },
				statuses: { added: keys.statuses, removed: new Set() },
				tags: { added: keys.tags, removed: new Set() },
				myDialog: keys.isMyDialog,
				unassigned: keys.isUnassigned,
				queue: keys.isQueue,
			};

			GroupingUtils.applyChanges(state, dialog.id, changes);
		});

		// Обновляем timestamp
		state.operator_panel.lastUpdateTimestamp = Date.now();
		state.operator_panel.rebuildKey = Date.now();
	},

	// Мутация для принудительного обновления реактивности Vue
	OP_TRIGGER_REACTIVITY_UPDATE(state) {
		state.operator_panel.rebuildKey = Date.now();
		// Пересоздаём все Map/Set для полной реактивности
		const cg = state.operator_panel.cachedGroupings;
		cg.byOperator = new Map(cg.byOperator);
		cg.bySubject = new Map(cg.bySubject);
		cg.byChannel = new Map(cg.byChannel);
		cg.byBot = new Map(cg.byBot);
		cg.byStatus = new Map(cg.byStatus);
		cg.byTag = new Map(cg.byTag);
		cg.myDialogs = new Set(cg.myDialogs);
		cg.unassigned = new Set(cg.unassigned);
		cg.queue = new Set(cg.queue);
		const gc = state.operator_panel.groupCounts;
		gc.operators = new Map(gc.operators);
		gc.subjects = new Map(gc.subjects);
		gc.channels = new Map(gc.channels);
		gc.bots = new Map(gc.bots);
		gc.statuses = new Map(gc.statuses);
		gc.tags = new Map(gc.tags);
	}
};

const actions = {
  opTriggerReactivityUpdateAndRebuild({ commit, dispatch, getters }) {
    commit('OP_TRIGGER_REACTIVITY_UPDATE');
    dispatch('rebuildAllGroupings');
  },
  opSetChatNotification({ commit }, data) {
    commit('OP_SET_CHAT_NOTINICATION', data);
  },
  opAddMessageToActiveChatRooms({ commit }, data) {
    commit('OP_ADD_MESSAGE_TO_ACTIVE_CHATROOMS', data);
  },

	opAddMessageToChatRoom({ commit }, data) {
		commit('OP_ADD_MESSAGE_TO_CHATROOM', data);
	},

  opSetChatReed({ commit }, data) {
    commit('OP_SET_CHAT_READ', data);
  },

  rebuildAllGroupings({ commit, getters }) {
    // Проверяем, включена ли принудительная оптимизация
    if (!getters.is_chat_rooms_hard_load) {
      // console.log('💡 Group optimization is disabled (is_chat_rooms_hard_load = false)');
      return;
    }

    const currentUserId = getters.opUserInfo?.id;
    if (!currentUserId) {
      console.warn('⚠️ Не удалось получить currentUserId для перестройки группировок');
      return;
    }
    commit('OP_REBUILD_ALL_GROUPINGS', currentUserId);
  },

  async OpAxiosGetChatRoomsRoot({ commit }, query) {
    const url = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/operator_panel/chat_room/list/`;

    const params = query ? { params: query } : null;

    const response = await axios.get(url, params).catch((err) => {
      HELPERS.handleError([
        err,
        i18n.t('common.error'),
        i18n.t('common.error_get'),
      ]);
      return null;
    });

    return response;
  },

  async OpAxiosGetChatRooms({ commit, dispatch, state }) {
    const response = await dispatch('OpAxiosGetChatRoomsRoot');

    if (response) {
      const serverTime = response.data?.data?.current_datetime || null;
      const chatRooms = response.data?.data?.chat_rooms || [];

      commit('OP_SET_SERVER_TIME', serverTime);
      commit('OP_SET_CHAT_ROOMS', chatRooms);

      // Перестраиваем группировки после установки данных
      if (state.operator_panel.needsGroupingRebuild) {
        dispatch('rebuildAllGroupings');
        state.operator_panel.needsGroupingRebuild = false;
      }

      dispatch('opSetChatRoomGroups', chatRooms);
    } else {
      commit('OP_SET_CHAT_ROOMS', []);
      commit('OP_SET_CHAT_ROOM_GROUPS', [])
    }
  },

	OpUpdateChatRoomState({ state, commit, getters }, chatRoom) {
		let prepareChatRoom = { ...chatRoom };
		if (!prepareChatRoom?.participants) prepareChatRoom['participants'] = [];
		if (!prepareChatRoom?.messages) prepareChatRoom['messages'] = [];
		const index = state.operator_panel.chatRooms.findIndex(obj => obj.id === chatRoom.id);
		const oldDialog = index !== -1 ? state.operator_panel.chatRooms[index] : null;
		commit('OP_UPDATE_CHAT_ROOM_STATE', { index, chatRoom: prepareChatRoom });
		updateDialogGroupsDebounced({ state, commit, getters }, { oldDialog, newDialog: prepareChatRoom });
	},

	OpUpdateStatusChatRoomState({ state, commit, getters }, chatRoom) {
		const index = state.operator_panel.chatRooms.findIndex(obj => obj.id === chatRoom.id);
		const oldDialog = index !== -1 ? state.operator_panel.chatRooms[index] : null;
		// console.log('🔄 OpUpdateStatusChatRoomState:', {
		// 	dialogId: chatRoom.id,
		// 	oldStatus: oldDialog?.status,
		// 	oldStatusName: oldDialog?.status_name,
		// 	newStatus: chatRoom?.status,
		// 	newStatusName: chatRoom?.status_name,
		// 	hasStatusUpdate: !!chatRoom?.status,
		// 	hasStatusNameUpdate: !!chatRoom?.status_name
		// });
		if (index !== -1) {
			// Создаем объект для обновления с правильными полями
			const updateData = { ...chatRoom };

			if (chatRoom?.status) {
				// Обновляем только status для папки queue
				commit('OP_UPDATE_STATUS_CHAT_ROOM_STATE', { index, status: chatRoom.status });


				// Обновляем только status_name для папки by_statuses
				commit('OP_UPDATE_STATUS_NAME_CHAT_ROOM_STATE', { index, status: chatRoom.status_name });

				if (getters.opChatRoomInfo?.id === chatRoom.id) {
					commit('OP_SET_ACTIVE_CHAT_INFO_VALUE_BY_KEY', { key: 'status', value: chatRoom.status });
					commit('OP_SET_ACTIVE_CHAT_INFO_VALUE_BY_KEY', { key: 'status_name', value: chatRoom.status_name });
				}
			}
			if (chatRoom?.type) {
				commit('OP_UPDATE_TYPE_CHAT_ROOM_STATE', { index, type: chatRoom.type });
				commit('OP_UPDATE_STATUS_NAME_CHAT_ROOM_STATE', { index, status: chatRoom.status_name });

				if (getters.opChatRoomInfo?.id === chatRoom.id) {
					commit('OP_SET_ACTIVE_CHAT_INFO_VALUE_BY_KEY', { key: 'type', value: chatRoom.type });
					commit('OP_SET_ACTIVE_CHAT_INFO_VALUE_BY_KEY', { key: 'status_name', value: chatRoom.status_name });
				}
			}

			commit('OP_UPDATE_TAGS_CHAT_ROOM_STATE', { index, chatroom_tags: chatRoom.chatroom_tags });

			//update ticket data in chatRoom
			if (chatRoom?.chatroom_ticket) {
				commit('OP_UPDATE_TYPE_CHAT_ROOM_TICKET', { index, chatroom_ticket: chatRoom.chatroom_ticket });
			}

			commit('OP_UPDATE_CHAT_ROOM_STATE_BY_KEY', { index, key: 'kw_chat_title', value: chatRoom.kw_chat_title });


			// Передаем правильный newDialog с обновленными полями
			const newDialog = { ...oldDialog, ...updateData };

			// Для критичных изменений обновляем немедленно без debounce
			const currentUserId = getters.opUserInfo?.id;
			if (currentUserId) {
				const oldKeys = GroupingUtils.extractGroupKeys(oldDialog, currentUserId);
				const newKeys = GroupingUtils.extractGroupKeys(newDialog, currentUserId);
				const changes = GroupingUtils.compareGroupKeys(oldKeys, newKeys);

				// Проверяем критичные изменения: queue или statuses
				if (changes.queue ||
					(changes.statuses.added.size > 0 || changes.statuses.removed.size > 0)) {
					GroupingUtils.applyChanges(state, newDialog.id, changes);
					commit('OP_TRIGGER_REACTIVITY_UPDATE');
					return; // Не вызываем debounced версию
				}
			}

			updateDialogGroupsDebounced({ state, commit, getters }, { oldDialog, newDialog });
		}
	},
	OpSetActiveChatInfoValueByKey({commit}, { key, value }){
		commit('OP_SET_ACTIVE_CHAT_INFO_VALUE_BY_KEY', { key, value })
	},
	OpRemoveChatRoomState({ state, commit, getters }, chat_room_id) {
		const index = state.operator_panel.chatRooms.findIndex(obj => obj.id === chat_room_id);
		const oldDialog = index !== -1 ? state.operator_panel.chatRooms[index] : null;
		commit('OP_REMOVE_CHAT_ROOM_STATE', chat_room_id);
		updateDialogGroupsDebounced({ state, commit, getters }, { oldDialog, newDialog: null });
	},
	OpUpdateParticipantChatRoomState({ state, commit, getters }, data) {
		const { chat_room_id, user_id, client, participant_id } = { ...data };
		const index = state.operator_panel.chatRooms.findIndex(obj => obj.id === chat_room_id);
		const oldDialog = index !== -1 ? state.operator_panel.chatRooms[index] : null;
		if (index !== -1) {
			let participants = JSON.parse(JSON.stringify(state.operator_panel.chatRooms[index]?.participants));
			if (user_id) {
				if (!participants.some((user) => user?.user_id && user?.user_id === user_id)) {
					const currentUser = state.operator_panel.fastUsersList?.find(({ id }) => id === user_id) || {};
					let userObj = { type: 'user', id: participant_id, user: JSON.parse(JSON.stringify(currentUser)), user_id: user_id };
					participants = [...participants, userObj];
				}
			}
			if (client) {
				if (!participants.some((user) => user?.client_id && user?.client_id === client.id)) {
					const clientObj = { type: 'client', id: participant_id, client: client, client_id: client.id };
					participants = [...participants, clientObj];
				}
			}
			commit('OP_UPDATE_PARTICIPANT_CHAT_ROOM_STATE', { index, participants });
			const newDialog = { ...oldDialog, participants };

			updateDialogGroupsDebounced({ state, commit, getters }, { oldDialog, newDialog });
		}
	},
	OpRemoveParticipantChatRoomState({ state, commit }, data) {
		const { chat_room_id, user_ids, client_id } = {...data}
		const index = state.operator_panel.chatRooms.findIndex(obj => obj.id === chat_room_id);

		if (index !== -1) {
			let participants = JSON.parse(JSON.stringify(state.operator_panel.chatRooms[index]?.participants))

			if(user_ids?.length) {
				for(const id of user_ids){
					if( participants.some((user) => user?.user_id && user?.user_id === id) ) {
						const indexUser = participants.findIndex(obj => obj.user_id === id);
						participants.splice(indexUser, 1);
					}
				}
			}

			if(client_id) {
				if( participants.some((user) => user?.client_id && user?.client_id === client_id) ) {
					const indexUser = participants.findIndex(obj => obj.client_id === client_id);
					participants.splice(indexUser, 1);
				}
			}


			commit('OP_REMOVE_PARTICIPANT_CHAT_ROOM_STATE', {
				index: index,
				participants: participants,
			})
		}



	},

  /**
   * Create new chat room
   * @method OpAxiosCreateChatRoom
   * @param chatRoomTitle
   *
   */
  async OpAxiosCreateChatRoom(
    { state, commit, dispatch },
    { chatRoomTitle, number, channel, clientId, type, botId, fromOperator }
  ) {
    if (number) number = number.replace(/[()\s\-.]/g, '');
    else number = '';

    let chat_room_request = {
      kw_channel: channel || 'kwizbot',
      kw_chat_id: number || uuid_v4(),
      subject_id: null,
      bot_id: botId || state?.bot_settings?.active_id,
      kw_chat_title: chatRoomTitle || null,
      type: type || null,
      from_operator: fromOperator || false,
    };

    /** СОЗДАЕМ НОВУЮ КОМНАТУ **/

    let url = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/operator_panel/chat_room/create/`;

    const {
			chat_room_id,
			existed,
			participants
		} = await axios
      .post(url, chat_room_request)
      .then((response) => {
        if (
          response.data &&
          response.data.data &&
          response.data.data.chat_room_id
        ) {
          return response.data.data;
        } else return 0;
      })
      .catch((err) => {
        HELPERS.handleError([
          err,
          i18n.t('common.error'),
          i18n.t('common.error_modify'),
        ]);
        return false;
      });

    if (!chat_room_id) {
      return 0;
    }

    /**ПОДКЛЮЧАЕМ ОПЕРАТОРА и псевдоклиента В ЧАТ СРАЗУ**/
    let participants_add_request = {
      chat_room_id,
      participants: [
        // {
        //   type: 'user',
        //   user_id: currentUserId,
        // },
        /* {
                "type": "client",
                "user_id":  client_id
            }*/
      ],
    };

		const currentUserId = state.operator_panel.userInfo.id;
    if (clientId) {
      participants_add_request.participants.push({
        type: 'client',
        client_id: clientId,
      });
    }

    url = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/operator_panel/chat_room/participants/add/`;

		if(
			!existed &&
			currentUserId &&
			!participants?.length
		) {
			participants_add_request.participants.push({
				type: 'user',
				user_id: currentUserId,
			});

			await axios.post(url, participants_add_request).catch((err) => {
				HELPERS.handleError([
					err,
					i18n.t('common.error'),
					i18n.t('common.error_modify'),
				]);
				return false;
			});
		}

    return {
			chat_room_id,
			existed,
			participants,
		};
  },

	async OpAxiosCreateEmailChatRoom({ state, commit, dispatch }, data) {

		let url = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/email/conversation_start/`;

		const {
			chat_room_id,
			existed,
			participants
		} = await axios
			.post(url, data)
			.then((response) => {
				if (
					response.data &&
					response.data.data &&
					response.data.data.chat_room_id
				) {
					return response.data.data;
				} else return 0;
			})
			.catch((err) => {
				HELPERS.handleError([
					err,
					i18n.t('common.error'),
					i18n.t('common.error_modify'),
				]);
				return false;
			});

		if (!chat_room_id) return 0;

		return {
			chat_room_id,
			existed,
			participants,
		};
	},

	async OpAxiosCreateCustomChatRoom({dispatch}, data) {
		let query = {
			channel: data?.channel,
			number: data?.kw_chat_id,
			subject_id: data?.subject_id,
			botId: data?.botId,
			chatRoomTitle: data?.chatRoomTitle,
			type: data?.type,
			fromOperator: data?.fromOperator || null,

			clientId: data?.clientId || null,
		};

		const {
			chat_room_id,
		} = await dispatch(
			'OpAxiosCreateChatRoom',
			query
		);

		if (chat_room_id) {
			await dispatch('updateAjaxDialog', [
				true,
				false,
				i18n.t('common.success'),
				i18n.t('modules.op.texts.chat_created'),
			])
		}

		return chat_room_id
	},

  async opGetSudjectList({ commit }) {
    const url = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/operator_panel/subjects/list/`;

    const subjects = await axios
      .get(url)
      .then((response) => {
        let subjectsList = response.data?.data?.subjects || []

        if (subjectsList.length) {
          subjectsList = subjectsList.filter( ({is_deleted}) => !is_deleted)
        }
        return subjectsList;
      })
      .catch((err) => {
        HELPERS.handleError([
          err,
          i18n.t('common.error'),
          i18n.t('common.error_get'),
        ]);
        return [];
      });

    commit('OP_SET_SUBJECT_LIST', subjects);
  },

  async opGetSubjectListTree({ commit }) {
    const url = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/operator_panel/subjects/listTree/`;

    const subjects = await axios
      .get(url)
      .then((response) => {
        return response.data?.data?.subjects || [];
      })
      .catch((err) => {
        HELPERS.handleError([
          err,
          i18n.t('common.error'),
          i18n.t('common.error_get'),
        ]);
        return [];
      });

    commit('OP_SET_SUBJECT_LIST_TREE', subjects);
  },

  async opAxiosChangeChatRoomTheme({ dispatch }, query) {
    const url = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/operator_panel/chat_room/subject/change/`;

    const { roomId, subjectId } = query;

    const request = {
      chat_room_id: roomId,
      subject_id: subjectId,
    };

    const success = await axios
      .post(url, request)
      .then((response) => {
        // if (response.data?.status === 'success') dispatch('OpAxiosGetChatRooms')
        return response.data?.status === 'success';
      })
      .catch((err) => {
        HELPERS.handleError([
          err,
          i18n.t('common.error'),
          i18n.t('common.error_modify'),
        ]);
        return false;
      });

    return success;
  },

  opSetActiveChatGroup({ commit }, chatGroupId) {
    commit('OP_SET_ACTIVE_CHAT_GROUP', chatGroupId);
  },

  opSetActiveChatRoom({ commit, getters }, chatRoomId) {
    commit('OP_SET_ACTIVE_CHAT_ROOM', chatRoomId);

    const activeChatRoom = getters.opActiveChatRoom;

    commit('OP_SET_CHAT_ROOM_PARTICIPANTS', activeChatRoom);

    commit(
      'OP_SET_ACTIVE_CHAT_ROOM_URL',
      chatRoomId || activeChatRoom?.id || null
    );

    commit('OP_SET_CHAT_READ', chatRoomId || activeChatRoom?.id || null);
  },
	opSetActiveChatRoomById({getters, dispatch}, chatRoomId) {
		// dispatch('OpAxiosGetChatRoomClientId', chatRoomId)
		dispatch('opSetActiveChatRoom', chatRoomId)

		const participants = getters.opActiveChatRoom?.participants || [];
		const isClient = (participant) => participant.type === 'client';
		const client = participants.find(isClient) || {};

		dispatch('opAxiosGetDialogInfo', chatRoomId)
		dispatch('opGetClientInfo', client.client_id)
		dispatch('opGetClientHistory', client.client_id)

		dispatch('opSetTopSidebarOpen', true)
		dispatch('opSetRightSidebarOpen', true)

		setTimeout(() => {
			dispatch('OpAxiosGetChatRoomMessages', chatRoomId);
		}, 250);
	},

  opSetActiveClosedChatRoom({ commit, getters }, data) {
    commit('OP_SET_ACTIVE_CHAT_ROOM', data.chat_room_id);
		commit('OP_SET_CLOSED_CHAT_ROOM_DATA', data)

    // const activeChatRoom = getters.opActiveChatRoom;

    // commit('OP_SET_CHAT_ROOM_PARTICIPANTS', activeChatRoom);

    // commit('OP_SET_CHAT_READ', chatRoomId || activeChatRoom?.id || null);
  },

  opClearActiveChatRoomOnDestroy({ commit, getter }, chatRoomId) {
    commit('OP_SET_ACTIVE_CHAT_ROOM', chatRoomId);

    const activeChatRoom = getters.opActiveChatRoom;

    commit('OP_SET_CHAT_ROOM_PARTICIPANTS', activeChatRoom);

    commit('OP_SET_CHAT_READ', chatRoomId || activeChatRoom?.id || null);
  },

  opSetTypeChatRooms ( {commit, getters}, typeChatRoomsVal ) {
    commit('OP_SET_TYPE_CHAT_ROOMS', typeChatRoomsVal);
    // commit('OP_TRIGGER_REACTIVITY_UPDATE'); // Откат: rebuildKey не должен обновляться при смене папки
  },

  opSetGroupByTheme ( {commit}, groupByTheme ) {
    commit('OP_SET_GROUP_BY_THEME', groupByTheme)
  },

  opSetChatRoomGroups ( {state, commit}, chatRooms = null ) {
    if (!chatRooms) chatRooms = state.operator_panel.chatRooms;

    const { subjectList } = state.operator_panel;

    const subjectObj = {
      alias: null,
      id: 0,
      name: i18n.t('modules.op.texts.without_subject'),
      name_en: 'Without theme',
      name_ru: i18n.t('modules.op.texts.without_subject'),
      name_uk: i18n.t('modules.op.texts.without_subject'),
      parent_id: null,
      dialogs: [],
      childSubjectIds: [0],
    };

    //sort ChatRooms
    const chatRoomsWithoutSubject = [];
    const chatRoomsWithSubject = [];

		//add dialogs with theme which not available for User
		const found = (chatroom_subject_id) => subjectList?.some(el => el.id === chatroom_subject_id);

    const sortChatRooms = (chatRoom) => {
      chatRoom.subject_id === null || ( chatRoom.subject_id && !found(chatRoom.subject_id))
        ? chatRoomsWithoutSubject.push(chatRoom)
        : chatRoomsWithSubject.push(chatRoom);
    };

    chatRooms.forEach(sortChatRooms);

    if (chatRoomsWithoutSubject.length) {
      chatRoomsWithoutSubject.forEach(function (chatRoom) {
        subjectObj.dialogs.push(chatRoom)
      })
    }

    let subjectListWithDialogs = []

    if (chatRoomsWithSubject.length) {
      for (let subject of subjectList) {
        subject['dialogs'] = chatRoomsWithSubject.filter( ({subject_id}) => subject.id === subject_id )
      }
      subjectListWithDialogs = subjectList.filter( ({dialogs}) => dialogs.length > 0 )
    }

    const chatRoomGroups = [subjectObj, ...subjectListWithDialogs]

    commit('OP_SET_CHAT_ROOM_GROUPS', chatRoomGroups)
  },

  opAxiosClosedRoomsByClients ({commit}, query) {
    const url = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/operator_panel/closed_rooms_by_clients/`;

    const params = query ? { params: query } : null;

    return axios
      .get(url, params)
      .then((response) => {
        return response.data?.data?.chat_rooms || [];
      })
      .catch((err) => {
        HELPERS.handleError([
          err,
          i18n.t('common.error'),
          i18n.t('common.error_get'),
        ]);
        return [];
      });
  },

  setClosedChatRoomsShow ({ commit }, value) {
    commit('OP_SET_CLOSED_CHAT_ROOMS_SHOW', value)
  },

  setSearchChatRoomsInput ( {commit}, value ) {
    commit('OP_SET_SEARCH_CHAT_ROOMS_INPUT', value)
  },

  setAxiosClosedRoomsSearch ({ commit, dispatch }, query) {
    dispatch("updateAjaxDialog", [true, true]);
    const url = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/operator_panel/closed_rooms_search/`;

    //increase date_to to One day, for request on back
		if (query?.to) {
			query.to = HELPERS.addOneDay(query.to)
		}

    const params = query ? { params: query } : null;

    return axios
      .get(url, params)
      .then((response) => {

				commit('OP_SET_CLOSED_ROOMS_SEARCH', response.data?.data?.chat_rooms || [])

				dispatch("updateAjaxDialog", [false, false]);
        return response.data?.data?.chat_rooms || [];
      })
      .catch((err) => {
        HELPERS.handleError([
          err,
          i18n.t('common.error'),
          i18n.t('common.error_get'),
        ]);
        return [];
      });
  },

  setClosedRoomsSearchParams({ commit }, option) {
    commit('OP_SET_CLOSED_ROOMS_SEARCH_PARAMS', option)
  },
	deleteClosedRoomsSearchParams({ commit }, option) {
		commit('OP_DELETE_CLOSED_ROOMS_SEARCH_PARAMS', option)
	},

	setClosedRoomsSearchParamsToDefault({ commit }) {
		commit('OP_SET_CLOSED_ROOMS_SEARCH_PARAMS_TO_DEFAULT')
	},

	opAxiosTagsList({ commit, getters }, data) {
		let {chatTags, request} = {...data}
		const url = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/operator_panel/tags/list/`;
		if (!request) request = {
			search: '',
			limit: 500,
			offset: 0,
		};

		return axios
			.get(url, request)
			.then((response) => {
				commit('OP_SET_TAGS_LIST', response?.data?.data?.tags || [])
				return response?.data?.data?.tags || []
			})
			.catch((err) => {
				HELPERS.handleError([
					err,
					i18n.t('common.error'),
					i18n.t('common.error_get'),
				]);
				return [];
			});
	},

	setClosedChatRoomsDataByValue({ commit }, option) {
		commit('OP_SET_CLOSED_CHAT_ROOM_DATA_BY_VALUE', option)
	},

	setChatRoomFolders({commit}, data) {
		commit('OP_SET_CHAT_ROOM_FOLDERS', data)
	},

  opClearGroupDialogsCache({ state, commit, getters }, { groupType, groupId }) {
    const cg = state.operator_panel.cachedGroupings;
    switch (groupType) {
      case 'operator':
      case 'by_operators':
        cg.byOperator.delete(groupId);
        break;
      case 'subject':
      case 'by_subjects':
        cg.bySubject.delete(groupId);
        break;
      case 'channel':
      case 'by_channels':
        cg.byChannel.delete(groupId);
        break;
      case 'bot':
      case 'by_bots':
        cg.byBot.delete(groupId);
        break;
      case 'status':
      case 'by_statuses':
        cg.byStatus.delete(groupId);
        break;
      case 'tag':
      case 'by_tags':
        cg.byTag.delete(groupId);
        break;
      case 'my':
        cg.myDialogs = new Set();
        break;
      case 'unassigned':
        cg.unassigned = new Set();
        break;
      case 'queue':
        cg.queue = new Set();
        break;
      case 'all':
        // Не очищаем, т.к. это все диалоги
        break;
      default:
        // Для остальных типов ничего не делаем
        break;
    }
    // После сброса кеша — пересчет только этой группы
    const currentUserId = getters.opUserInfo?.id;
    GroupingUtils.rebuildGroup(state, groupType, groupId, currentUserId);
    commit('OP_TRIGGER_REACTIVITY_UPDATE');
  },

  async opAxiosChannelMessagesReactions({state, commit}, channel){
    if(
      state.operator_panel.channels_message_reactions_config.hasOwnProperty(channel)
    ) return

    const url = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/operator_panel/reactions/config/${channel}`;

    await axios
      .get(url)
      .then((response) => {
        commit('OP_SET_CHANNELS_MESSAGE_REACTIONS_CONFIG', {
          channel: channel,
          data: response.data?.data?.reactions || [],
        })

      })
      .catch((err) => {
        HELPERS.handleError([
          err,
          i18n.t('common.error'),
          i18n.t('common.error_get'),
        ]);
      });
  },
};

// Кэш для опRoomsByFolderType (вынесен из геттера чтобы избежать циклических зависимостей)
let opRoomsByFolderTypeCache = {
	cache: new Map(),
	lastDataHash: null
};

const getters = {
  opIsNotification: (state) => {
    const { notification } = state.operator_panel;

    return notification;
  },

	opChatRoomsOrigin: (state) => state.operator_panel.chatRooms,

  opChatRooms: (state) => {
    const { chatRooms } = state.operator_panel;

    // Создаем копии объектов, чтобы не мутировать оригинальный state
    const chatRoomsWithDate = chatRooms.map(room => {
      //TODO: too many errors here
      if(!room?.createdAt) {
        console.log(room, 'opChatRooms getter with createdAt')
      }

      const date = room?.createdAt ? new Date(room.createdAt) : new Date();
      const formatDate = INTL.format(date);

      // Возвращаем новый объект с добавленным полем date
      return {
        ...room,
        date: formatDate
      };
    });

    return chatRoomsWithDate;
  },

  opChatRoomGroups2: (state) => {
    const { chatRooms, subjectList } = state.operator_panel;

    let chatRoomGroups = [];

    const subjectObj = {
        alias: null,
        id: 0,
        name: i18n.t('modules.op.texts.without_subject'),
        name_en: 'Without theme',
        name_ru: i18n.t('modules.op.texts.without_subject'),
        name_uk: i18n.t('modules.op.texts.without_subject'),
        parent_id: null,
        dialogs: [],
        childSubjectIds: [0],
    };

    //sort ChatRooms
    const chatRoomsWithoutSubject = [];
    const chatRoomsWithSubject = [];

    const sortChatRooms = (chatRoom) => {
      chatRoom.subject_id === null
        ? chatRoomsWithoutSubject.push(chatRoom)
        : chatRoomsWithSubject.push(chatRoom);
    };

    chatRooms.forEach(sortChatRooms);

    if (chatRoomsWithoutSubject.length) {
      chatRoomsWithoutSubject.forEach(function (chatRoom) {
        subjectObj.dialogs.push(chatRoom)
      })
      chatRoomGroups.push(subjectObj)
    }

    if (chatRoomsWithSubject.length) {

      chatRoomsWithSubject.forEach(function (chatRoom) {
        for (let i in subjectList) {
          if (subjectList[i].id === chatRoom.subject_id) {
            if (subjectList[i]?.dialogs === undefined) subjectList[i]['dialogs'] = []
            subjectList[i]?.dialogs.push(chatRoom)
            chatRoomGroups.push( subjectList[i] )
          }
        }
      })
    }

    return chatRoomGroups
  },

  opChatRoomsWithGroup: (state) => {
    const { chatRooms, subjectList } = state.operator_panel;
    const chatRoomsWithSubjects = chatRooms.filter( ({subject_id}) => subject_id != null )

    for (let subject of subjectList) {
      subject['dialogs'] = chatRoomsWithSubjects.filter( ({subject_id}) => subject.id === subject_id )
    }

    return subjectList.filter( (subject) => subject.dialogs.length > 0)
  },

  opChatRoomsWithoutGroup (state) {
    const { chatRooms } = state.operator_panel;
    return  chatRooms.filter( ({subject_id}) => subject_id === null )
  },

  opActiveChatGroup: (state, getters) => {
    const activeChatGroupId = state.operator_panel.activeChatGroup;

    const isEqualId = (group) => group.id === activeChatGroupId;

    // const activeGroup = getters.opChatRoomGroups.find(isEqualId);
    const activeGroup = state.operator_panel.chatRoomGroups.find(isEqualId);

    return activeGroup || null;
  },

  opActiveChatRoom: (state) => {
    const { chatRooms } = state.operator_panel;

    const activeChatRoomId = state.operator_panel.activeChatRoom;

    if (activeChatRoomId === null) {
      return null;
    }

    const isEqualId = (room) => room.id === activeChatRoomId;

    const activeChatRoom = chatRooms.find(isEqualId);

    return activeChatRoom || null;
  },

  opActiveChatRoomFromState: (state) => state.operator_panel.activeChatRoom,

  opServerTime: (state) => state.operator_panel.serverTime,

  opSubjectList: (state) => state.operator_panel.subjectList,

  opSubjectListTree: (state) => state.operator_panel.subjectListTree,

  opRebuildKey: (state) => state.operator_panel.rebuildKey,

  opTypeChatRooms: (state) => state.operator_panel.typeChatRooms,
  opTypeChatRoomsEnum: (state) => state.operator_panel.typeChatRoomsEnum,

  opGroupByTheme: (state) => state.operator_panel.groupByTheme,

  opChatRoomGroupsNew: (state) => state.operator_panel.chatRoomGroups,

  opClosedChatRoomsShow: (state) => state.operator_panel.closedChatRoomsShow,

  opSearchChatRoomsInput: (state) => state.operator_panel.searchChatRoomsInput,

  /**
   * @name opFilteredChatRooms
   * @description main function for filter chat rooms by search and type
   * @param state
   * @param getters
   * @returns filtered array of chatRooms
   */
  opFilteredChatRooms: (state, getters) => {
    const searchVal = (getters.opSearchChatRoomsInput === null)
      ? ''
      : getters.opSearchChatRoomsInput.toLowerCase();
    const dialogs = getters.opChatRooms || [];

    const isClient = (participant) => participant.type === 'client';
    const isUser = (participant) => participant.type === 'user';

    const concatInfo = (acc, infoValue) => acc + " " + infoValue;

    const isEqualSearch = (client) => {
      const clientInfoObj = client.client || {};
      const clientInfo = Object.values(clientInfoObj).reduce(
        concatInfo,
        ''
      );
      const normClientInfo = clientInfo.toLowerCase();

      return normClientInfo.includes(searchVal);
    };

    const compareClientFullName = (dialog) => {
      const clients = dialog.participants.filter(isClient);
      return clients.some(isEqualSearch);
    };

		const compareChatTitle = (dialog) => {
			return dialog?.kw_chat_title?.includes(searchVal) || false
		};

    const userId = getters.opUserInfo.id;

    const isEqualUserId = (user) => user.user_id === userId;

    //filter for unassigned dialogs
    const compareDialogUnassigned = (dialog) => {
      const users = dialog.participants.filter( ({type}) => type === 'user' );
      return users.length <= 0;
    };

    //filter assigned to current user
    const compareDialogUser = (dialog) => {
      const users = dialog.participants.filter(isUser);
      return dialog?.type !== 'ticket' && users.some(isEqualUserId);
    };

		//filter Ticket is assigned to current user
		const compareTicketUser = (dialog) => {
			return dialog?.type === 'ticket' && dialog?.chatroom_ticket?.assignee_id === userId;
		};
		const compareTicketReporterUser = (dialog) => {
			return dialog?.type === 'ticket' && dialog?.chatroom_ticket?.reporter_id === userId;
		};
		const compareOutdated = (dialog) => {
			return dialog?.type === 'ticket' && dialog?.chatroom_ticket?.outdated;
		};
		const compareResolved = (dialog) => {
			return dialog?.type === 'ticket' && dialog?.chatroom_ticket?.resolved;
		};
		const comparePaused = (dialog) => {
			return dialog?.type === 'ticket' && dialog?.chatroom_ticket?.paused;
		};

		//filter assigned to current user
		const compareDialogQueue = (dialog) => {
			return dialog.status === 'queue';
		};

		//filter is last Client message
		const compareDialogNoAnswer = (dialog) => {
			const participants = dialog?.participants || []
			const array = dialog?.messages || []

			if (
				participants?.length === 0 ||
				array?.length === 0
			) return false;

			const findClientId = (id) => participants?.find(item => item?.type === 'client' && item.id === id)?.id
			const lastElement = array[array.length - 1];
			if (!findClientId(lastElement?.participant_id)) return false;

			let count = 0;
			for (let i = array.length - 1; i >= 0; i--) {
				if (findClientId(array[i]?.participant_id)) {
					count++;
				} else {
					break;
				}
			}

			return count > 0;
		};

    //filter assigned to user by ID
    const compareDialogUserById = (dialog, userId) => {
      const users = dialog.participants.filter(isUser);
      return users.some((user) => user.user_id === userId);
    };

    const compareDialogSubjectById = (dialog, subjectId) => {
      return (subjectId === 0)
        ? dialog.subject_id === null
        : dialog.subject_id === subjectId
    };

		const compareDialogSkillGroupById = (dialog, skillGroupName) => {
			if(!dialog?.subject_id) return false

			const skillGroupId = getters.opSkillGroupsList?.skill_groups.find(item => item.name === skillGroupName)?.id

			return getters.opSkillGroupsList?.skill_groups_to_subjects
				?.find(item => item.skill_group_id === skillGroupId && item.subject_id === dialog.subject_id)
		};

		const compareDialogChannelsByName = (dialog, channelName) => {
			return dialog.kw_channel === channelName
		};

		const compareDialogBotById = (dialog, bot_id) => {
			return dialog.bot_id === bot_id
		};

		const compareDialogStatusByName = (dialog, status) => {
			return dialog.status_name === status
		};

		const compareDialogTagByName = (dialog, tagName) => {
			return dialog.chatroom_tags?.some((tag) => tag.name === tagName);
		};

		//filters by room Types
		const folderFilterByTypes = (key) => getters.opChatRoomFolders?.find(item => item.key === key)?.filter_by_type || []
		const compareDialogFromFolderFilterByTypes = (key, dialog) => {
			if(folderFilterByTypes(key).length) {
				const types = folderFilterByTypes(key)

				if(
          types.includes('chat')
          && (dialog.type === null || dialog.type === 'group' || dialog.type === 'comment')
        ) return dialog
				if(types.includes(dialog.type)) return dialog
			} else return dialog
		};
		//end filters by room Types

    const ifTested = (dialog) => {
      const ifPassFullName =
        searchVal === '' || compareClientFullName(dialog) || compareChatTitle(dialog);

      //filter from ChatsMenu.vue
      let isPassTypeCheck
      switch (getters.opTypeChatRooms?.type) {
        case getters.opTypeChatRoomsEnum.all:
          isPassTypeCheck = compareDialogFromFolderFilterByTypes('all', dialog)
          break;
        case getters.opTypeChatRoomsEnum.unassigned:
          isPassTypeCheck = compareDialogUnassigned(dialog) && compareDialogFromFolderFilterByTypes('unassigned', dialog)
          break;
        case getters.opTypeChatRoomsEnum.my:
          isPassTypeCheck = compareDialogUser(dialog)
          break;
				case getters.opTypeChatRoomsEnum.ticket_assignee_my:
          isPassTypeCheck = compareTicketUser(dialog)
          break;
				case getters.opTypeChatRoomsEnum.ticket_reporter_me:
          isPassTypeCheck = compareTicketReporterUser(dialog)
          break;
				case getters.opTypeChatRoomsEnum.outdated:
					isPassTypeCheck = compareOutdated(dialog)
					break;
				case getters.opTypeChatRoomsEnum.resolved:
					isPassTypeCheck = compareResolved(dialog)
					break;
				case getters.opTypeChatRoomsEnum.paused:
					isPassTypeCheck = comparePaused(dialog)
					break;
				case getters.opTypeChatRoomsEnum.queue:
					isPassTypeCheck = compareDialogQueue(dialog) &&
						compareDialogFromFolderFilterByTypes('queue', dialog)
					break;
        case getters.opTypeChatRoomsEnum.operator:
          isPassTypeCheck = compareDialogUserById(dialog, getters.opTypeChatRooms.id) &&
						compareDialogFromFolderFilterByTypes('by_operators', dialog)
          break;
        case getters.opTypeChatRoomsEnum.subject:
          isPassTypeCheck = compareDialogSubjectById(dialog, getters.opTypeChatRooms.id) &&
						compareDialogFromFolderFilterByTypes('by_subjects', dialog)
          break;

				case getters.opTypeChatRoomsEnum.skill_group:
					isPassTypeCheck = compareDialogSkillGroupById(dialog, getters.opTypeChatRooms.id) &&
						compareDialogFromFolderFilterByTypes('by_skill_groups', dialog)
					break;
				case getters.opTypeChatRoomsEnum.channel:
					isPassTypeCheck = compareDialogChannelsByName(dialog, getters.opTypeChatRooms.id) &&
						compareDialogFromFolderFilterByTypes('by_channels', dialog)
					break;
				case getters.opTypeChatRoomsEnum.bot:
					isPassTypeCheck = compareDialogBotById(dialog, getters.opTypeChatRooms.id) &&
						compareDialogFromFolderFilterByTypes('by_bots', dialog)
					break;
				case getters.opTypeChatRoomsEnum.status:
					isPassTypeCheck = compareDialogStatusByName(dialog, getters.opTypeChatRooms.id) &&
						compareDialogFromFolderFilterByTypes('by_statuses', dialog)
					break;
				case getters.opTypeChatRoomsEnum.tag:
					isPassTypeCheck = compareDialogTagByName(dialog, getters.opTypeChatRooms.id) &&
						compareDialogFromFolderFilterByTypes('by_tags', dialog)
					break;
				case getters.opTypeChatRoomsEnum.no_answer:
					isPassTypeCheck = compareDialogNoAnswer(dialog) &&
						compareDialogFromFolderFilterByTypes('no_answer', dialog)
					break;
        default:
          isPassTypeCheck = false
      }

      return ifPassFullName && isPassTypeCheck;
    };

    let filteredDialogs = dialogs.filter(ifTested);

		//sorting
		//default sorting
    const byDateDesc = (a, b) => {
      const aLastMsg = a.messages[a.messages.length - 1];
      const aLastMsgTime = aLastMsg?.send_datetime;
      const aDialogTime = a.start_datetime;
      const aStartTime = aLastMsgTime || aDialogTime;

      const bLastMsg = b.messages[b.messages.length - 1];
      const bLastMsgTime = bLastMsg?.send_datetime;
      const bDialogTime = b.start_datetime;
      const bStartTime = bLastMsgTime || bDialogTime;

      const aDate = new Date(aStartTime);
      const bDate = new Date(bStartTime);

      const aTime = aDate.getTime();
      const bTime = bDate.getTime();

      return aTime - bTime;
    };

		//by created(id) sorting
		const byCreatedDesc = (a, b) => {
			return a.id - b.id;
		}

		//by last user added sorting
		const byUserDesc = (a, b) => {
			const aUsers = a?.participants?.filter(item => item?.user_id) || []
			const aUserId = aUsers.length
				? aUsers?.reduce(function(prev, current) {
					return (prev && prev.id > current.id) ? prev : current
				}).id
				: 0

			const bUsers = b?.participants?.filter(item => item?.user_id) || []
			const bUserId = bUsers.length
				? bUsers?.reduce(function(prev, current) {
					return (prev && prev.id > current.id) ? prev : current
				}).id
				: 0

			return aUserId - bUserId
		}

		//by message read sorting
		const byReadDesc = (a, b) => {
			const aLastMsg = a.messages[a.messages.length - 1];
			const aMessageRead = aLastMsg?.message_read ? 0 : 1

			const bLastMsg = b.messages[b.messages.length - 1];
			const bMessageRead = bLastMsg?.message_read ? 0 : 1

			return aMessageRead - bMessageRead
		}


		function switchSorting(sortingMode) {
			switch (sortingMode) {
				case 'default':
					return filteredDialogs.sort(byDateDesc).reverse();
				case 'created':
					return filteredDialogs.sort(byCreatedDesc).reverse();
				case 'user':
					return filteredDialogs.sort(byUserDesc).reverse();
				case 'message_read':
					filteredDialogs = filteredDialogs.sort(byDateDesc)
					return filteredDialogs.sort(byReadDesc).reverse();
				default:
					return filteredDialogs.sort(byDateDesc).reverse();
			}
		}

		return switchSorting(state.operator_panel.chatRoomsSorting)
  },

  opClosedRoomsSearch: (state) => state.operator_panel.closedRoomsSearch,
  opClosedRoomsSearchParams: (state) => state.operator_panel.closedRoomsSearchParams,
	opClosedRoomsSearchParamsDefault: (state) => state.operator_panel.closedRoomsSearchParamsDefault,
  opClosedRoomsSearchParamGroupByEnum: (state) => state.operator_panel.closedRoomsSearchParamGroupByEnum,
  opTagsList: (state) => state.operator_panel.tagsList,
	opClosedChatRoomData: (state) => state.operator_panel.closedChatRoomData,

	opChatRoomFolders: (state) => state.operator_panel.chatRoomFolders,
	opChatRoomFoldersDefault: (state) => state.operator_panel.chatRoomFoldersDefault,
	opChatRoomsSortingEnum: (state) => state.operator_panel.chatRoomsSortingEnum,

	opChatRoomsSorting: (state) => state.operator_panel.chatRoomsSorting,

	opPinRightPanelOpen: (state) => {
		//state.operator_panel.userSettingsJson
		if(
			state.operator_panel.userSettingsJson?.pin_right_panel_by_default_user === 0
			|| state.operator_panel.userSettingsJson?.pin_right_panel_by_default_user
		) return state.operator_panel.userSettingsJson?.pin_right_panel_by_default_user

		//state.operator_panel.settings
		const pin_right_panel_by_default =  state.operator_panel.settings.find(s => s.key === 'pin_right_panel_by_default')
		return parseInt(pin_right_panel_by_default?.value) || false
	},

	opRightPanelDefaultTab: (state) => {
		//state.operator_panel.userSettingsJson
		if(
			state.operator_panel.userSettingsJson?.right_panel_default_tab_user === 0
			|| state.operator_panel.userSettingsJson?.right_panel_default_tab_user
		) return state.operator_panel.userSettingsJson?.right_panel_default_tab_user

		//state.operator_panel.settings
		const right_panel_default_tab =  state.operator_panel.settings.find(s => s.key === 'right_panel_default_tab')
		return parseInt(right_panel_default_tab?.value) || false
	},

	/**
	 * OPTIMIZED CHAT ROOMS COUNTERS FOR PERFORMANCE
	 * Централизованные оптимизированные геттеры для подсчета чатов
	 */

	// Кэшированные Map'ы для быстрого поиска
	opChatRoomsLookupMaps: (state, getters) => {
		const chatRooms = getters.opChatRooms || [];
		const userId = getters.opUserInfo?.id;

		// Создаем индексы для быстрого поиска
		const maps = {
			byType: new Map(),
			byStatus: new Map(),
			byChannel: new Map(),
			byBotId: new Map(),
			bySubjectId: new Map(),
			userParticipants: new Map(),
			clientParticipants: new Map(),
			byTags: new Map(),
		};

		// Заполняем Map'ы одним проходом по массиву
		chatRooms.forEach(room => {
			// НЕ нормализуем тип - сохраняем оригинальное значение
			const roomType = room.type; // null остается null, 'chat' остается 'chat'

			// Группировка по типу
			if (!maps.byType.has(roomType)) {
				maps.byType.set(roomType, []);
			}
			maps.byType.get(roomType).push(room);

			// Группировка по статусу
			if (room.status_name) {
				if (!maps.byStatus.has(room.status_name)) {
					maps.byStatus.set(room.status_name, []);
				}
				maps.byStatus.get(room.status_name).push(room);
			}

			// Группировка по каналу
			if (room.kw_channel) {
				if (!maps.byChannel.has(room.kw_channel)) {
					maps.byChannel.set(room.kw_channel, []);
				}
				maps.byChannel.get(room.kw_channel).push(room);
			}

			// Группировка по боту
			if (room.bot_id) {
				if (!maps.byBotId.has(room.bot_id)) {
					maps.byBotId.set(room.bot_id, []);
				}
				maps.byBotId.get(room.bot_id).push(room);
			}

			// Группировка по subject_id
			const subjectId = room.subject_id || 'null';
			if (!maps.bySubjectId.has(subjectId)) {
				maps.bySubjectId.set(subjectId, []);
			}
			maps.bySubjectId.get(subjectId).push(room);

			// Индексация участников
			if (room.participants) {
				room.participants.forEach(participant => {
					if (participant.type === 'user' && participant.user_id) {
						if (!maps.userParticipants.has(participant.user_id)) {
							maps.userParticipants.set(participant.user_id, []);
						}
						maps.userParticipants.get(participant.user_id).push(room);
					}

					if (participant.type === 'client') {
						if (!maps.clientParticipants.has(room.id)) {
							maps.clientParticipants.set(room.id, []);
						}
						maps.clientParticipants.get(room.id).push(participant);
					}
				});
			}

				// Группировка по тегам
			if (room.chatroom_tags && room.chatroom_tags.length) {
				room.chatroom_tags.forEach(tag => {
					if (!maps.byTags.has(tag.name)) {
						maps.byTags.set(tag.name, []);
					}
					maps.byTags.get(tag.name).push(room);
				});
			}
		});

		return maps;
	},

	// Фильтрация чатов по типу папки (оптимизированная без внутреннего кэша)
	opRoomsByFolderType: (state, getters) => {
		return (folderKey, limit = null) => {
			const folders = state.operator_panel.chatRoomFolders;
			const folder = folders.find(f => f.key === folderKey);
			if (!folder) return [];

			let result = [];

			// Проверяем, включена ли принудительная оптимизация
			const isHardLoadEnabled = getters.is_chat_rooms_hard_load;

			if (isHardLoadEnabled) {
				// Используем оптимизированную логику с кэшированными группировками
				const maps = getters.opChatRoomsLookupMaps;

				switch (folderKey) {
					case 'my': {
						result = getters.opGroupDialogsFast('my');
						result = filterRoomsByType(result, folder.filter_by_type);
						return result;
					}
					case 'unassigned': {
						result = state.operator_panel.chatRooms.filter(
							room => !(room.participants && room.participants.some(p => p.type === 'user'))
						);
						result = filterRoomsByType(result, folder.filter_by_type);
						return result;
					}
					case 'queue': {
						result = getters.opGroupDialogsFast('queue');
						break;
					}
					case 'all': {
						result = getters.opGroupDialogsFast('all');
						break;
					}
					case 'ticket_assignee_my': {
						const chatRooms = getters.opChatRooms || [];
						result = chatRooms.filter(room => room.type === 'ticket' && room.chatroom_ticket?.assignee_id === getters.opUserInfo?.id);
						break;
					}
					case 'ticket_reporter_me': {
						const chatRooms = getters.opChatRooms || [];
						result = chatRooms.filter(room => room.type === 'ticket' && room.chatroom_ticket?.reporter_id === getters.opUserInfo?.id);
						break;
					}
					case 'resolved': {
						const chatRooms = getters.opChatRooms || [];
						result = chatRooms.filter(room => room.type === 'ticket' && room.chatroom_ticket?.resolved);
						break;
					}
					case 'outdated': {
						const chatRooms = getters.opChatRooms || [];
						result = chatRooms.filter(room => room.type === 'ticket' && room.chatroom_ticket?.outdated);
						break;
					}
					case 'paused': {
						const chatRooms = getters.opChatRooms || [];
						result = chatRooms.filter(room => room.type === 'ticket' && room.chatroom_ticket?.paused);
						break;
					}
					default: {
						const chatRooms = getters.opChatRooms || [];
						let sourceRooms = chatRooms;
						if (folder.filter_by_type && folder.filter_by_type.length) {
							sourceRooms = filterRoomsByType(chatRooms, folder.filter_by_type);
						}
						switch (folderKey) {
							case 'all':
								result = sourceRooms;
								break;
							case 'unassigned':
								result = sourceRooms.filter(room => {
									const userParticipants = room.participants?.filter(p => p.type === 'user') || [];
									return userParticipants.length === 0;
								});
								break;
							case 'no_answer': {
								result = sourceRooms.filter(room => {
									const participants = Array.isArray(room.participants) ? room.participants : [];
									const messages = Array.isArray(room.messages) ? room.messages : [];
									if (participants.length === 0 || messages.length === 0) return false;
									const clientParticipants = participants.filter(p => p.type === 'client');
									if (clientParticipants.length === 0) return false;
									const lastMessage = messages[messages.length - 1];
									const isLastMessageFromClient = clientParticipants.some(
										participant => participant.id === lastMessage?.participant_id
									);
									if (!isLastMessageFromClient) return false;
									let count = 0;
									for (let i = messages.length - 1; i >= 0; i--) {
										const isFromClient = clientParticipants.some(
											participant => participant.id === messages[i]?.participant_id
										);
										if (!isFromClient) break;
										count++;
									}
									return count > 0;
								});
								break;
							}
							default:
								result = sourceRooms;
						}
					}
				}
			} else {
				// Используем простую фильтрацию без кэширования
				const chatRooms = getters.opChatRooms || [];
				let sourceRooms = chatRooms;

				if (folder.filter_by_type && folder.filter_by_type.length) {
					sourceRooms = filterRoomsByType(chatRooms, folder.filter_by_type);
				}

				switch (folderKey) {
					case 'all':
						result = sourceRooms;
						break;
					case 'my':
						result = sourceRooms.filter(room =>
							room.participants?.some(p => p.type === 'user' && p.user_id === getters.opUserInfo?.id) &&
							room.type !== 'ticket'
						);
						break;
					case 'unassigned':
						result = sourceRooms.filter(room =>
							!(room.participants && room.participants.some(p => p.type === 'user'))
						);
						break;
					case 'queue':
						result = sourceRooms.filter(room => room.status === 'queue');
						break;
					case 'ticket_assignee_my':
						result = sourceRooms.filter(room =>
							room.type === 'ticket' && room.chatroom_ticket?.assignee_id === getters.opUserInfo?.id
						);
						break;
					case 'ticket_reporter_me':
						result = sourceRooms.filter(room =>
							room.type === 'ticket' && room.chatroom_ticket?.reporter_id === getters.opUserInfo?.id
						);
						break;
					case 'resolved':
						result = sourceRooms.filter(room =>
							room.type === 'ticket' && room.chatroom_ticket?.resolved
						);
						break;
					case 'outdated':
						result = sourceRooms.filter(room =>
							room.type === 'ticket' && room.chatroom_ticket?.outdated
						);
						break;
					case 'paused':
						result = sourceRooms.filter(room =>
							room.type === 'ticket' && room.chatroom_ticket?.paused
						);
						break;
					case 'no_answer': {
						result = sourceRooms.filter(room => {
							const participants = Array.isArray(room.participants) ? room.participants : [];
							const messages = Array.isArray(room.messages) ? room.messages : [];
							if (participants.length === 0 || messages.length === 0) return false;
							const clientParticipants = participants.filter(p => p.type === 'client');
							if (clientParticipants.length === 0) return false;
							const lastMessage = messages[messages.length - 1];
							const isLastMessageFromClient = clientParticipants.some(
								participant => participant.id === lastMessage?.participant_id
							);
							if (!isLastMessageFromClient) return false;
							let count = 0;
							for (let i = messages.length - 1; i >= 0; i--) {
								const isFromClient = clientParticipants.some(
									participant => participant.id === messages[i]?.participant_id
								);
								if (!isFromClient) break;
								count++;
							}
							return count > 0;
						});
						break;
					}
					default:
						result = sourceRooms;
				}
			}

			if (limit && limit > 0) {
				result = result.slice(0, limit);
			}
			// Финальный фильтр по типу для item/group папок
			if ((folder.type === 'item' || folder.type === 'group') && folder.filter_by_type && folder.filter_by_type.length) {
				result = filterRoomsByType(result, folder.filter_by_type);
			}
			return result;
		};
	},

	// Точный подсчет для активных элементов (оптимизированный)
	opChatRoomsExactCount: (state, getters) => (folderKey) => {
		const folders = state.operator_panel.chatRoomFolders;
		const folder = folders.find(f => f.key === folderKey);
		let result = [];

		// Проверяем, включена ли принудительная оптимизация
		const isHardLoadEnabled = getters.is_chat_rooms_hard_load;

		if (isHardLoadEnabled) {
			// Используем оптимизированную логику
			if (folderKey === 'all') {
				result = state.operator_panel.chatRooms;
				result = filterRoomsByType(result, folder.filter_by_type)
				return result?.length || 0;
			}
			if (folderKey === 'my') {
				result = state.operator_panel.chatRooms.filter((room) =>
					room.participants.some( (p) => p?.user_id === getters.opUserInfo?.id ) &&
					room?.type !== 'ticket');
				result = filterRoomsByType(result, folder.filter_by_type)
				return result?.length || 0;
			}
			if (folderKey === 'unassigned') {
				// Точное количество диалогов без операторов
				result = state.operator_panel.chatRooms.filter(
					room => !(room.participants && room.participants.some(p => p.type === 'user'))
				);
				result = filterRoomsByType(result, folder.filter_by_type)
				return result?.length || 0;
			}
			if (folderKey === 'queue') {
				return state.operator_panel.cachedGroupings.queue.size;
			}
			// ⚡ Используем быстрые счетчики для остальных папок
			const fastCount = getters.opGroupCountFast(folderKey);
			if (fastCount !== undefined && fastCount !== 0) {
				return fastCount;
			}
		}

		// Fallback для остальных случаев или когда оптимизация отключена
		const rooms = getters.opRoomsByFolderType(folderKey);
		return rooms.length;
	},

	// Быстрый подсчет с лимитом (оптимизированный)
	opChatRoomsCount: (state, getters) => (folderKey, limit = null) => {
		// Проверяем, включена ли принудительная оптимизация
		if (getters.is_chat_rooms_hard_load) {
			// ⚡ Для основных папок используем быстрые счетчики
			const fastCount = getters.opGroupCountFast(folderKey);
			if (fastCount !== undefined && fastCount !== 0) {
				return limit ? Math.min(fastCount, limit) : fastCount;
			}
		}

		// Fallback для остальных случаев или когда оптимизация отключена
		const rooms = getters.opRoomsByFolderType(folderKey, limit);
		return rooms.length;
	},

	// Проверка, превышает ли количество лимит (оптимизированный)
	opChatRoomsHasMore: (state, getters) => (folderKey, limit = 100) => {
		// Проверяем, включена ли принудительная оптимизация
		if (getters.is_chat_rooms_hard_load) {
			// ⚡ Для основных папок используем быстрые счетчики
			const fastCount = getters.opGroupCountFast(folderKey);
			if (fastCount !== undefined && fastCount !== 0) {
				return fastCount >= limit;
			}
		}

		// Fallback для остальных случаев или когда оптимизация отключена
		const rooms = getters.opRoomsByFolderType(folderKey, limit);
		return rooms.length >= limit;
	},

	// Геттеры для групп (операторы, каналы, боты и т.д.)
	opOperatorsWithChats: (state, getters) => {
		const chatRooms = state.operator_panel.chatRooms || [];
		const operators = [];
		// Собираем уникальных операторов из всех диалогов
		chatRooms.forEach(room => {
			const userParticipants = room.participants?.filter(p => p.type === 'user' && p.user_id) || [];
			userParticipants.forEach(participant => {
				if (!operators.find(op => op.id === participant.user_id)) {
					operators.push({
						id: participant.user_id,
						first_name: participant.user?.first_name || '',
						last_name: participant.user?.last_name || '',
						...participant.user
					});
				}
			});
		});
		// Сортировка по имени
		return operators.sort((a, b) => (a.first_name + a.last_name).localeCompare(b.first_name + b.last_name));
	},

	// ⚡ ОПТИМИЗИРОВАННЫЕ геттеры с использованием кэшированных группировок
	opDialogsByOperators: (state, getters) => {
		// Проверяем, включена ли принудительная оптимизация
		if (!getters.is_chat_rooms_hard_load) {
			// Используем старую логику без кэширования
			const chatRooms = state.operator_panel.chatRooms || [];
			const operators = [];
			const operatorsMap = new Map();

			// Собираем операторов и их диалоги
			chatRooms.forEach(room => {
				const userParticipants = room.participants?.filter(p => p.type === 'user' && p.user_id) || [];
				userParticipants.forEach(participant => {
					const operatorId = participant.user_id;
					if (!operatorsMap.has(operatorId)) {
						const operator = getters.opFastUsersList?.find(user => user.id === operatorId) || {};
						operatorsMap.set(operatorId, {
							id: operatorId,
							first_name: operator.first_name || participant.user?.first_name || '',
							last_name: operator.last_name || participant.user?.last_name || '',
							email: operator.email || participant.user?.email || '',
							name: `${operator.first_name || ''} ${operator.last_name || ''}`.trim() || operator.email || `User ${operatorId}`,
							dialogs: []
						});
					}
					operatorsMap.get(operatorId).dialogs.push(room);
				});
			});

			// Преобразуем Map в массив
			return Array.from(operatorsMap.values());
		}

		// Используем оптимизированную логику с кэшом
		const { cachedGroupings, chatRooms } = state.operator_panel;
		const result = [];

		// ⚡ Используем кэшированные группировки вместо maps
		cachedGroupings.byOperator.forEach((dialogIds, operatorId) => {
			if (dialogIds.size > 0) {
				// Получаем диалоги по ID из кэша
				const dialogs = chatRooms.filter(dialog => dialogIds.has(dialog.id));

				// Получаем информацию об операторе
				const operator = getters.opFastUsersList?.find(user => user.id === operatorId) || {};

				result.push({
					id: operatorId,
					first_name: operator.first_name || '',
					last_name: operator.last_name || '',
					email: operator.email || '',
					name: `${operator.first_name || ''} ${operator.last_name || ''}`.trim() || operator.email || `User ${operatorId}`,
					dialogs: dialogs // ⚡ Полный список без ограничений
				});
			}
		});

		return result;
	},

	opDialogsByChannels: (state, getters) => {
		const { cachedGroupings, chatRooms } = state.operator_panel;
		const result = [];
		cachedGroupings.byChannel.forEach((dialogIds, channelName) => {
			if (dialogIds.size > 0) {
				const dialogs = chatRooms.filter(dialog => dialogIds.has(dialog.id));
				result.push({
					name: channelName,
					id: channelName,
					dialogs: dialogs
				});
			}
		});
		// Сортировка по имени канала
		return result.sort((a, b) => a.name.localeCompare(b.name));
	},

	opDialogsByBots: (state, getters) => {
		const { cachedGroupings, chatRooms } = state.operator_panel;
		const bots = getters.bots || [];
		const result = [];
		cachedGroupings.byBot.forEach((dialogIds, botId) => {
			const bot = bots.find(b => b.id === botId);
			if (bot && dialogIds.size > 0) {
				const dialogs = chatRooms.filter(dialog => dialogIds.has(dialog.id));
				result.push({
					id: botId,
					name: bot.name,
					dialogs: dialogs
				});
			}
		});
		// Сортировка по имени бота
		return result.sort((a, b) => a.name.localeCompare(b.name));
	},

	opDialogsBySubjects: (state, getters) => {
		const { cachedGroupings, chatRooms } = state.operator_panel;
		const subjects = getters.opSubjectList || [];
		const result = [];
		subjects.forEach(subject => {
			const subjectId = subject.id;
			const dialogIds = cachedGroupings.bySubject.get(subjectId);
			if (dialogIds && dialogIds.size > 0) {
				const dialogs = chatRooms.filter(dialog => dialogIds.has(dialog.id));
				result.push({
					id: subject.id,
					name: subject.name,
					dialogs: dialogs
				});
			}
		});
		const dialogsWithoutSubject = cachedGroupings.bySubject.get('null');
		if (dialogsWithoutSubject && dialogsWithoutSubject.size > 0) {
			const dialogs = chatRooms.filter(dialog => dialogsWithoutSubject.has(dialog.id));
			result.push({
				id: null,
				name: 'Без темы',
				dialogs: dialogs
			});
		}
		// Сортировка по имени темы
		return result.sort((a, b) => a.name.localeCompare(b.name));
	},

	opDialogsBySkillGroups: (state, getters) => {
		const { chatRooms } = state.operator_panel;
		const skillGroupsList = getters.opSkillGroupsList || {};
		const skillGroups = skillGroupsList.skill_groups || [];
		const skillGroupsToSubjects = skillGroupsList.skill_groups_to_subjects || [];
		const folderConfig = getters.opChatRoomFolders?.find(item => item.key === 'by_skill_groups');
		const filterTypes = folderConfig?.filter_by_type || [];
		const filteredDialogs = chatRooms.filter(dialog => {
			if (filterTypes.length) {
				if (filterTypes.includes('chat') && (dialog.type === null || dialog.type === 'group' || dialog.type === 'comment')) return true;
				if (filterTypes.includes(dialog.type)) return true;
				return false;
			}
			return true;
		});
		const result = [];
		filteredDialogs.forEach(dialog => {
			if (dialog.subject_id && skillGroupsToSubjects.length) {
				const sg_ids = skillGroupsToSubjects.filter(item => item.subject_id === dialog.subject_id) || [];
				if (sg_ids.length) {
					sg_ids.forEach(sg_id => {
						const sg = skillGroups.find(item => item.id === sg_id.skill_group_id);
						const sg_name = sg?.name;
						const sg_id_val = sg?.id;
						if (!sg_name) return;
						let group = result.find(item => item.id === sg_id_val);
						if (group) {
							group.dialogs.push(dialog);
						} else {
							result.push({
								name: sg_name,
								id: sg_id_val,
								dialogs: [dialog]
							});
						}
					});
				}
			}
		});
		// Сортировка по имени skill group
		return result.sort((a, b) => a.name.localeCompare(b.name));
	},

	opDialogsByTags: (state, getters) => {
		state.operator_panel.rebuildKey;
		const { cachedGroupings, chatRooms } = state.operator_panel;
		const result = [];
		cachedGroupings.byTag.forEach((dialogIds, tagName) => {
			if (dialogIds.size > 0) {
				const dialogs = chatRooms.filter(dialog => dialogIds.has(dialog.id));
				let tagColor = 'primary';
				const firstDialog = dialogs[0];
				if (firstDialog?.chatroom_tags) {
					const tag = firstDialog.chatroom_tags.find(t => t.name === tagName);
					if (tag?.color) {
						tagColor = tag.color;
					}
				}
				result.push({
					id: tagName,
					name: tagName,
					color: tagColor,
					dialogs: dialogs
				});
			}
		});
		// Сортировка по имени тега
		return result.sort((a, b) => a.name.localeCompare(b.name));
	},

	opDialogsByStatuses: (state, getters) => {
		const { cachedGroupings, chatRooms } = state.operator_panel;
		const result = [];
		cachedGroupings.byStatus.forEach((dialogIds, statusName) => {
			if (dialogIds.size > 0) {
				const dialogs = chatRooms.filter(dialog => dialogIds.has(dialog.id));
				let statusDisplayName = statusName;
				const firstWithStatus = dialogs.find(d => d.status_name);
				if (firstWithStatus && firstWithStatus.status_name) {
					statusDisplayName = firstWithStatus.status_name;
				}
				result.push({
					id: statusName,
					name: statusDisplayName,
					dialogs: dialogs
				});
			}
		});
		// Сортировка по имени статуса
		return result.sort((a, b) => a.name.localeCompare(b.name));
	},

	// ⚡ БЫСТРЫЕ ОПТИМИЗИРОВАННЫЕ ГЕТТЕРЫ (используют кэшированные группировки)

	// Быстрый подсчет количества диалогов в группе
	opGroupCountFast: (state, getters) => (groupType, groupId = null) => {
		// Добавляю зависимость для реактивности
		state.operator_panel.rebuildKey;

		// Проверяем, включена ли принудительная оптимизация
		if (!getters.is_chat_rooms_hard_load) {
			// Если оптимизация отключена, возвращаем 0 для fallback на точный подсчет
			return 0;
		}

		const { groupCounts } = state.operator_panel;

		// Основные папки
		switch (groupType) {
			case 'my':
				return groupCounts.my;
			case 'unassigned':
				return groupCounts.unassigned;
			case 'queue':
				// console.log('🎯 opGroupCountFast queue:', {
				// 	queueCount: groupCounts.queue,
				// 	queueCacheSize: state.operator_panel.cachedGroupings.queue.size,
				// 	isOptimizationEnabled: getters.is_chat_rooms_hard_load
				// });
				return groupCounts.queue;
			case 'all':
				return groupCounts.all;
		}

		// Групповые папки с ID
		if (groupId !== null) {
			switch (groupType) {
				case 'operator':
				case 'by_operators':
					return groupCounts.operators.get(groupId) || 0;
				case 'subject':
				case 'by_subjects':
					return groupCounts.subjects.get(groupId) || 0;
				case 'channel':
				case 'by_channels':
					return groupCounts.channels.get(groupId) || 0;
				case 'bot':
				case 'by_bots':
					return groupCounts.bots.get(groupId) || 0;
				case 'status':
				case 'by_statuses':
					return groupCounts.statuses.get(groupId) || 0;
				case 'tag':
				case 'by_tags':
					state.operator_panel.rebuildKey;
					return groupCounts.tags.get(groupId) || 0;
				case 'skill_group':
				case 'by_skill_groups': {
					// Подсчет вручную для skill_group
					const skillGroupsList = getters.opSkillGroupsList || {};
					const skillGroupsToSubjects = skillGroupsList.skill_groups_to_subjects || [];
					const chatRooms = state.operator_panel.chatRooms || [];
					const subjectIds = skillGroupsToSubjects
						.filter(item => item.skill_group_id == groupId)
						.map(item => item.subject_id);
					return chatRooms.filter(dialog => subjectIds.includes(dialog.subject_id)).length;
				}
			}
		}
		// Для остальных типов папок возвращаем 0 чтобы всегда был fallback на точный пересчет
		return 0;
	},

	// Быстрое получение диалогов группы
	opGroupDialogsFast: (state, getters) => (groupType, groupId) => {
		// Добавляю зависимость для реактивности
		state.operator_panel.rebuildKey;

		// Проверяем, включена ли принудительная оптимизация
		if (!getters.is_chat_rooms_hard_load) {
			// Если оптимизация отключена, возвращаем пустой массив для fallback
			return [];
		}

		const { cachedGroupings, chatRooms } = state.operator_panel;
		let dialogIds = new Set();

		switch (groupType) {
			case 'my':
				dialogIds = cachedGroupings.myDialogs;
				break;
			case 'unassigned':
				dialogIds = cachedGroupings.unassigned;
				break;
			case 'queue':
				dialogIds = cachedGroupings.queue;
				break;
			case 'all':
				// Для 'all' возвращаем все диалоги
				return chatRooms;
			case 'operator':
				dialogIds = cachedGroupings.byOperator.get(groupId) || new Set();
				break;
			case 'subject':
				dialogIds = cachedGroupings.bySubject.get(groupId) || new Set();
				break;
			case 'channel':
				dialogIds = cachedGroupings.byChannel.get(groupId) || new Set();
				break;
			case 'bot':
				dialogIds = cachedGroupings.byBot.get(groupId) || new Set();
				break;
			case 'status':
				dialogIds = cachedGroupings.byStatus.get(groupId) || new Set();
				break;
			case 'tag':
				state.operator_panel.rebuildKey;
				dialogIds = cachedGroupings.byTag.get(groupId) || new Set();
				break;
			default:
				return [];
		}

		// Преобразуем Set<dialogId> в массив диалогов
		return chatRooms.filter(dialog => dialogIds.has(dialog.id));
	},

	// Статистика оптимизации (для отладки)
	opOptimizationStats: (state) => {
		const { cachedGroupings, groupCounts, lastUpdateTimestamp, pendingUpdates } = state.operator_panel;

		return {
			totalDialogs: state.operator_panel.chatRooms.length,
			lastUpdateTimestamp,
			pendingUpdatesCount: pendingUpdates.size,
			groupingsCount: {
				operators: cachedGroupings.byOperator.size,
				subjects: cachedGroupings.bySubject.size,
				channels: cachedGroupings.byChannel.size,
				bots: cachedGroupings.byBot.size,
				statuses: cachedGroupings.byStatus.size,
				tags: cachedGroupings.byTag.size,
			},
			countersTotal: {
				my: groupCounts.my,
				unassigned: groupCounts.unassigned,
				queue: groupCounts.queue,
				all: groupCounts.all,
			}
		};
	},

	// Геттер для получения элементов групповых папок
	opReturnItemsInGroupByKey: (state, getters) => (key) => {
		// Проверяем, включена ли принудительная оптимизация
		if (getters.is_chat_rooms_hard_load) {
			// Используем оптимизированные геттеры
			switch (key) {
				case 'by_operators':
					return getters.opDialogsByOperators || [];
				case 'by_subjects':
					return getters.opDialogsBySubjects || [];
				case 'by_skill_groups':
					return getters.opDialogsBySkillGroups || [];
				case 'by_channels':
					return getters.opDialogsByChannels || [];
				case 'by_bots':
					return getters.opDialogsByBots || [];
				case 'by_statuses':
					return getters.opDialogsByStatuses || [];
				case 'by_tags':
					return getters.opDialogsByTags || [];
				default:
					return [];
			}
		} else {
			// Используем простую логику без кэширования
			const chatRooms = state.operator_panel.chatRooms || [];
			const folder = state.operator_panel.chatRoomFolders.find(f => f.key === key);
			const filterTypes = folder?.filter_by_type || [];

			// Фильтруем диалоги по типу
			let filteredDialogs = chatRooms;
			if (filterTypes.length) {
				filteredDialogs = filterRoomsByType(chatRooms, filterTypes);
			}

			switch (key) {
				case 'by_operators': {
					const operatorsMap = new Map();
					filteredDialogs.forEach(room => {
						const userParticipants = room.participants?.filter(p => p.type === 'user' && p.user_id) || [];
						userParticipants.forEach(participant => {
							const operatorId = participant.user_id;
							if (!operatorsMap.has(operatorId)) {
								const user = getters.opFastUsersList?.find(u => u.id === operatorId) || participant.user || {};
								operatorsMap.set(operatorId, {
									id: operatorId,
									first_name: user.first_name || '',
									last_name: user.last_name || '',
									email: user.email || '',
									name: `${user.first_name || ''} ${user.last_name || ''}`.trim() || user.email || `User ${operatorId}`
								});
							}
						});
					});
					return Array.from(operatorsMap.values());
				}
				case 'by_subjects': {
					const subjectsMap = new Map();
					const subjects = getters.opSubjectList || [];

					// Добавляем темы из списка
					subjects.forEach(subject => {
						subjectsMap.set(subject.id, {
							id: subject.id,
							name: subject.name
						});
					});

					// Добавляем "Без темы" если есть диалоги без subject_id
					const hasDialogsWithoutSubject = filteredDialogs.some(room => !room.subject_id);
					if (hasDialogsWithoutSubject) {
						subjectsMap.set(null, {
							id: null,
							name: 'Без темы'
						});
					}

					// Фильтруем только те темы, у которых есть диалоги
					return Array.from(subjectsMap.values()).filter(subject => {
						return filteredDialogs.some(room =>
							subject.id === null ? !room.subject_id : room.subject_id === subject.id
						);
					});
				}
				case 'by_skill_groups': {
					const skillGroupsList = getters.opSkillGroupsList || {};
					const skillGroups = skillGroupsList.skill_groups || [];
					const skillGroupsToSubjects = skillGroupsList.skill_groups_to_subjects || [];
					const skillGroupsMap = new Map();

					filteredDialogs.forEach(room => {
						if (room.subject_id && skillGroupsToSubjects.length) {
							const sg_ids = skillGroupsToSubjects.filter(item => item.subject_id === room.subject_id) || [];
							sg_ids.forEach(sg_id => {
								const sg = skillGroups.find(item => item.id === sg_id.skill_group_id);
								if (sg && !skillGroupsMap.has(sg.id)) {
									skillGroupsMap.set(sg.id, {
										id: sg.id,
										name: sg.name
									});
								}
							});
						}
					});

					return Array.from(skillGroupsMap.values());
				}
				case 'by_channels': {
					const channelsMap = new Map();
					filteredDialogs.forEach(room => {
						if (room.kw_channel && !channelsMap.has(room.kw_channel)) {
							channelsMap.set(room.kw_channel, {
								id: room.kw_channel,
								name: room.kw_channel
							});
						}
					});
					return Array.from(channelsMap.values());
				}
				case 'by_bots': {
					const botsMap = new Map();
					const bots = getters.bots || [];
					filteredDialogs.forEach(room => {
						if (room.bot_id && !botsMap.has(room.bot_id)) {
							const bot = bots.find(b => b.id === room.bot_id);
							if (bot) {
								botsMap.set(room.bot_id, {
									id: room.bot_id,
									name: bot.name
								});
							}
						}
					});
					return Array.from(botsMap.values());
				}
				case 'by_statuses': {
					const statusesMap = new Map();
					filteredDialogs.forEach(room => {
						if (room.status_name && !statusesMap.has(room.status_name)) {
							statusesMap.set(room.status_name, {
								id: room.status_name,
								name: room.status_name
							});
						}
					});
					return Array.from(statusesMap.values());
				}
				case 'by_tags': {
					const tagsMap = new Map();
					filteredDialogs.forEach(room => {
						if (room.chatroom_tags && room.chatroom_tags.length) {
							room.chatroom_tags.forEach(tag => {
								if (!tagsMap.has(tag.name)) {
									tagsMap.set(tag.name, {
										id: tag.name,
										name: tag.name,
										color: tag.color
									});
								}
							});
						}
					});
					return Array.from(tagsMap.values());
				}
				default:
					return [];
			}
		}
	},

	// Геттер для подсчета диалогов в элементе группы
	opCalculateChatRoomsByGroup: (state, getters) => (key, element) => {
		// Получаем настройки папки
		const folder = state.operator_panel.chatRoomFolders.find(f => f.key === key);
		const filterTypes = folder?.filter_by_type || [];

		// Если оптимизация включена, используем быстрые счетчики
		if (getters.is_chat_rooms_hard_load) {
			return getters.opGroupCountFast(folder?.item_key || key.replace('by_', ''), element.id) || 0;
		}

		// Иначе считаем вручную
		const chatRooms = state.operator_panel.chatRooms || [];
		let filteredDialogs = chatRooms;

		// Применяем фильтр по типу
		if (filterTypes.length) {
			filteredDialogs = filterRoomsByType(chatRooms, filterTypes);
		}

		// Фильтруем по конкретному элементу группы
		switch (key) {
			case 'by_operators':
				return filteredDialogs.filter(room =>
					room.participants?.some(p => p.type === 'user' && p.user_id === element.id)
				).length;
			case 'by_subjects':
				return filteredDialogs.filter(room =>
					element.id === null ? !room.subject_id : room.subject_id === element.id
				).length;
			case 'by_skill_groups': {
				const skillGroupsList = getters.opSkillGroupsList || {};
				const skillGroupsToSubjects = skillGroupsList.skill_groups_to_subjects || [];
				const subjectIds = skillGroupsToSubjects
					.filter(item => item.skill_group_id === element.id)
					.map(item => item.subject_id);
				return filteredDialogs.filter(room =>
					room.subject_id && subjectIds.includes(room.subject_id)
				).length;
			}
			case 'by_channels':
				return filteredDialogs.filter(room =>
					room.kw_channel === element.id
				).length;
			case 'by_bots':
				return filteredDialogs.filter(room =>
					room.bot_id === element.id
				).length;
			case 'by_statuses':
				return filteredDialogs.filter(room =>
					room.status_name === element.id
				).length;
			case 'by_tags':
				return filteredDialogs.filter(room =>
					room.chatroom_tags?.some(tag => tag.name === element.id)
				).length;
			default:
				return 0;
		}
	},

  opChannelMessageReactionsConfig: (state) => (channel) => state.operator_panel.channels_message_reactions_config?.[channel] || [],
};

// 1. Добавляю debounce-экшен для точечного обновления групп
const updateDialogGroupsDebounced = _.debounce(function({ state, commit, getters }, { oldDialog, newDialog }) {
  const currentUserId = getters.opUserInfo?.id;
  if (!currentUserId) return;
  if (!oldDialog && !newDialog) return;
  const oldKeys = oldDialog ? GroupingUtils.extractGroupKeys(oldDialog, currentUserId) : GroupingUtils.extractGroupKeys({}, currentUserId);
  const newKeys = newDialog ? GroupingUtils.extractGroupKeys(newDialog, currentUserId) : GroupingUtils.extractGroupKeys({}, currentUserId);
  const changes = GroupingUtils.compareGroupKeys(oldKeys, newKeys);
  GroupingUtils.applyChanges(state, newDialog?.id || oldDialog?.id, changes);
  // Триггерим реактивность для groupCounts
  commit('OP_TRIGGER_REACTIVITY_UPDATE');
}, 100);

// Фильтрация диалогов по типу, как в roomsFolderFilterByTypes
function filterRoomsByType(rooms, types) {
  if (!rooms?.length) return [];
  if (!types?.length) return rooms;
  return rooms.filter(room => {
    if (types.includes('chat') && (room.type === null || room.type === 'group' || room.type === 'comment')) return true;
    if (types.includes(room.type)) return true;
    return false;
  });
}

export default {
  state,
  mutations,
  actions,
  getters,
};

